(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ura-arrival-showroom"] && !Shopify.designMode) return;
  try {
    (()=>{
  const instances=new Map(),reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const clamp=(v,a=0,b=1)=>Math.max(a,Math.min(b,v)),ease=v=>{v=clamp(v);return v*v*(3-2*v);};
  let viewerRuntime;
  const loadViewer=()=>{if(customElements.get('model-viewer'))return Promise.resolve();if(viewerRuntime)return viewerRuntime;viewerRuntime=new Promise((resolve,reject)=>{const script=document.createElement('script');script.type='module';script.src='https://ajax.googleapis.com/ajax/libs/model-viewer/4.1.0/model-viewer.min.js';script.onload=()=>customElements.whenDefined('model-viewer').then(resolve);script.onerror=()=>{viewerRuntime=undefined;script.remove();reject(new Error('Model viewer unavailable'));};document.head.append(script);});return viewerRuntime;};
  const mount=scope=>scope.querySelectorAll('.uac--story[data-uac]').forEach(root=>{
    if(instances.has(root))return;
    const win=root.querySelector('[data-uac-window]'),track=root.querySelector('[data-uac-track]'),pin=root.querySelector('.uac-pin');
    const scenes=[...root.querySelectorAll('[data-uac-scene]')].map(el=>({el,photos:[...el.querySelectorAll('[data-uac-photo]')],companions:[...el.querySelectorAll('[data-uac-companion]')],buttons:[...el.querySelectorAll('[data-uac-photo-button]')],stage:-1,start:0,hold:1}));
    if(!win||!track||!scenes.length)return;
    const abort=new AbortController(),signal=abort.signal,controls=root.querySelector('[data-uac-controls]'),prev=root.querySelector('[data-uac-prev]'),next=root.querySelector('[data-uac-next]'),counter=root.querySelector('[data-uac-current]'),countText=root.querySelector('[data-uac-count-text]');
    let top=80,height=600,width=1,total=1,unit=320,transit=450,lead=60,active=-1,frame=0,resizeTimer=0,lastWidth=innerWidth,enabled=false,openDialog=null,returnFocus=null,previousOverflow='';
    const set=(node,key,value)=>node.style.setProperty(key,String(value));
    const showPhotos=(scene,p,manual=false)=>{
      const n=scene.photos.length;if(!n)return;
      p=clamp(p,0,n);const radius=innerWidth<=760?.32:.34;const boundary=Math.round(p);let low=Math.min(n-1,Math.floor(p)),high=low,blend=0;
      if(!manual&&boundary>0&&boundary<n&&Math.abs(p-boundary)<radius){low=boundary-1;high=boundary;blend=ease((p-boundary+radius)/(radius*2));}
      const selected=blend>.5?high:low;
      const draw=(photo,index,companion=false)=>{const opacity=index===low?1-blend:index===high?blend:0;set(photo,'--uac-photo-opacity',index===low||index===high?'1':'0');photo.style.clipPath=index===high&&high!==low?(innerWidth<=760?'inset(0 0 0 '+((1-blend)*100).toFixed(3)+'%)':'inset('+((1-blend)*100).toFixed(3)+'% 0 0)'):index===low&&high!==low?(innerWidth<=760?'inset(0 '+(blend*100).toFixed(3)+'% 0 0)':'inset(0 0 '+(blend*100).toFixed(3)+'%)'):'inset(0)';set(photo,companion?'--uac-companion-y':'--uac-photo-y',`${reduced.matches?0:((1-opacity)*(companion?-5:5)).toFixed(2)}px`);set(photo,companion?'--uac-companion-scale':'--uac-photo-scale',(reduced.matches?1:(companion?.988:.994)+opacity*(companion?.012:.006)).toFixed(4));photo.toggleAttribute('data-uac-photo-active',index===selected);photo.inert=index!==selected;photo.setAttribute('aria-hidden',String(index!==selected));};
      scene.photos.forEach((photo,i)=>draw(photo,i));scene.companions.forEach((photo,i)=>draw(photo,i,true));
      scene.buttons.forEach((button,i)=>set(button,'--uac-phase-progress',manual?(i<=selected?1:0):clamp(p-i).toFixed(3)));
      if(scene.stage!==selected){scene.stage=selected;scene.el.dataset.uacStage=String(selected);scene.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)));}
    };
    const select=i=>{if(i===active)return;active=i;counter.textContent=String(i+1).padStart(2,'0');countText.textContent=countText.dataset.template.replace('[current]',String(i+1));prev.disabled=i===0;next.disabled=i===scenes.length-1;};
    const paint=()=>{
      frame=0;if(!enabled||!root.isConnected||openDialog)return;
      const rect=root.getBoundingClientRect();if(rect.bottom<top||rect.top>innerHeight){root.querySelectorAll('model-viewer').forEach(v=>v.removeAttribute('auto-rotate'));return;}
      const targetOffset=clamp(top-rect.top-lead,0,total),now=performance.now();if(renderedOffset===null)renderedOffset=targetOffset;const delta=Math.min(40,lastPaint?now-lastPaint:16.67);lastPaint=now;renderedOffset+=(targetOffset-renderedOffset)*(1-Math.exp(-delta/(innerWidth<=760?180:140)));if(Math.abs(targetOffset-renderedOffset)<.05)renderedOffset=targetOffset;const offset=renderedOffset;let index=scenes.length-1;
      for(let i=0;i<scenes.length;i++){if(offset<scenes[i].start+scenes[i].hold+(i<scenes.length-1?transit:0)){index=i;break;}}
      const scene=scenes[index],local=offset-scene.start,transition=index<scenes.length-1?ease((local-scene.hold)/transit):0,station=index+transition;
      set(root,'--uac-x',`${(-station*width).toFixed(2)}px`);set(root,'--uac-progress',(offset/total).toFixed(4));select(Math.round(station));
      scenes.forEach((s,i)=>{const distance=Math.abs(i-station);s.el.inert=distance>.58;if(distance>1.25)return;showPhotos(s,i<index?s.photos.length:i>index?0:clamp(local/unit,0,s.photos.length));set(s.el,'--uac-object-y',`${reduced.matches?0:Math.sin(clamp(local/s.hold)*Math.PI)*-5}px`);const viewer=s.el.querySelector('model-viewer');if(viewer)viewer.toggleAttribute('auto-rotate',distance<.35&&!reduced.matches&&!viewer.hasAttribute('data-user-camera'));});
      if(Math.abs(targetOffset-renderedOffset)>.05&&!document.hidden)queue();
    };
    let renderedOffset=null,lastPaint=0;
    const queue=()=>{if(!frame)frame=requestAnimationFrame(paint);};
    const measure=()=>{
      if(openDialog)return;
      const header=document.querySelector('[data-ura-header]'),preview=document.getElementById('PBarNextFrame');
      top=Math.ceil(header?.getBoundingClientRect().height||72);
      const viewportHeight=Math.floor(window.visualViewport?.height||innerHeight),previewRect=preview?.getBoundingClientRect();
      const previewInset=previewRect?Math.min(100,Math.max(0,Math.min(viewportHeight,previewRect.bottom)-Math.max(0,previewRect.top))):0;
      height=viewportHeight-top-previewInset-4;
      const mobile=innerWidth<=760;
      const headHeight=root.querySelector('.uac-head').getBoundingClientRect().height;
      const recordHeight=Math.max(...scenes.map(s=>s.el.querySelector('.uac-scene__record').getBoundingClientRect().height));
      const footerHeight=Math.max(mobile?60:64,root.querySelector('.uac-foot').getBoundingClientRect().height);
      const minimum=mobile?360:headHeight+Math.max(recordHeight,250)+footerHeight;
      enabled=!reduced.matches&&height>=minimum&&(scenes.length>1||scenes.some(s=>s.photos.length>1));
      root.toggleAttribute('data-uac-pinned',enabled);controls.hidden=!enabled||scenes.length<2;
      root.dataset.uacDensity=mobile?(height<540?'tight':height<680?'compact':'roomy'):'roomy';
      set(root,'--uac-top',`${top}px`);set(root,'--uac-height',`${height}px`);
      width=win.getBoundingClientRect().width;unit=mobile?clamp(height*1.05,560,800):clamp(height*.75,440,660);transit=mobile?clamp(width*1.35,520,760):clamp(width*.55,420,620);lead=Math.min(72,height*.085);total=0;
      scenes.forEach((s,i)=>{s.start=total;s.hold=Math.max(1,s.photos.length)*unit;total+=s.hold+(i<scenes.length-1?transit:0);});
      root.style.height=enabled?`${Math.ceil(height+total+lead*2)}px`:'';
      if(!enabled){set(root,'--uac-x','0px');set(root,'--uac-progress','0');scenes.forEach(s=>{s.el.inert=false;showPhotos(s,Math.max(0,s.stage)+.5,true);s.el.querySelector('model-viewer')?.removeAttribute('auto-rotate');});}
      lastWidth=innerWidth;queue();
    };
    const scheduleMeasure=()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>{if(root.isConnected)measure();},180);};
    // Safari toolbar resizes must not change the story length during a swipe.
    const viewportResize=()=>{if(Math.abs(innerWidth-lastWidth)>2||matchMedia('(pointer:fine)').matches)scheduleMeasure();else queue();};
    const travelTo=(scene,photo=0)=>{const destination=scrollY+root.getBoundingClientRect().top-top+lead+scene.start+(photo+.5)*unit;window.scrollTo({top:destination,behavior:reduced.matches?'auto':'smooth'});};
    const go=index=>{if(enabled)travelTo(scenes[clamp(index,0,scenes.length-1)]);};
    scenes.forEach(scene=>{scene.el.querySelector('[data-uac-photos]').setAttribute('data-uac-ready','');const nav=scene.el.querySelector('[data-uac-photo-nav]');nav.hidden=scene.photos.length<2;showPhotos(scene,.5,true);scene.buttons.forEach((button,i)=>button.addEventListener('click',()=>{if(enabled)travelTo(scene,i);else showPhotos(scene,i+.5,true);},{signal}));});
    root.querySelector('.uac-skip')?.addEventListener('click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const target=document.getElementById(event.currentTarget.hash.slice(1));
      if(!target)return;
      event.preventDefault();
      const destination=scrollY+target.getBoundingClientRect().top-top;
      target.focus({preventScroll:true});
      window.scrollTo({top:destination,behavior:reduced.matches?'auto':'smooth'});
    },{signal});
    prev.addEventListener('click',()=>go(active-1),{signal});next.addEventListener('click',()=>go(active+1),{signal});controls.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();go(active+(event.key==='ArrowLeft'?-1:1));}},{signal});
    root.querySelectorAll('[data-uac-quick]').forEach(link=>{link.setAttribute('aria-haspopup','dialog');link.setAttribute('aria-controls',link.dataset.uacQuick);link.addEventListener('click',event=>{if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;const dialog=document.getElementById(link.dataset.uacQuick);if(!dialog?.showModal)return;event.preventDefault();returnFocus=link;openDialog=dialog;previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();},{signal});});
    root.querySelectorAll('.uac-dialog').forEach(dialog=>{
      dialog.querySelector('[data-uac-close]').addEventListener('click',()=>dialog.close(),{signal});dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}},{signal});dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;openDialog=null;returnFocus?.focus({preventScroll:true});scheduleMeasure();queue();},{signal});
      const image=dialog.querySelector('figure img'),originalSrc=image?.getAttribute('src'),originalSrcset=image?.getAttribute('srcset');dialog.querySelector('[data-uac-variant]')?.addEventListener('change',event=>{const option=event.target.selectedOptions[0];if(option?.dataset.price)dialog.querySelector('[data-uac-price]').textContent=option.dataset.price;if(!image)return;if(option?.dataset.image){image.removeAttribute('srcset');image.src=option.dataset.image;}else{if(originalSrc)image.src=originalSrc;if(originalSrcset)image.setAttribute('srcset',originalSrcset);else image.removeAttribute('srcset');}},{signal});
    });
    root.querySelectorAll('[data-uac-model]').forEach(shell=>{let viewer=shell.querySelector('model-viewer'),loadTimer=0,attempt=0;const button=shell.querySelector('[data-uac-load-model]'),error=shell.querySelector('.uac-model-error');const failed=()=>{clearTimeout(loadTimer);shell.removeAttribute('aria-busy');error.hidden=false;button.hidden=false;button.disabled=false;viewer.removeAttribute('auto-rotate');};const bind=()=>{viewer.addEventListener('error',failed,{signal});viewer.addEventListener('load',()=>{clearTimeout(loadTimer);shell.removeAttribute('aria-busy');button.disabled=false;button.hidden=true;error.hidden=true;queue();},{signal});viewer.addEventListener('camera-change',event=>{if(event.detail?.source==='user-interaction'){viewer.setAttribute('data-user-camera','');viewer.removeAttribute('auto-rotate');}},{signal});};bind();button.addEventListener('click',async()=>{if(attempt++){const replacement=viewer.cloneNode(true);replacement.removeAttribute('src');replacement.removeAttribute('data-user-camera');viewer.replaceWith(replacement);viewer=replacement;bind();}button.disabled=true;error.hidden=true;shell.setAttribute('aria-busy','true');loadTimer=setTimeout(failed,20000);try{await loadViewer();if(!root.isConnected)return;viewer.src=viewer.dataset.modelSrc;viewer.dismissPoster();}catch{failed();}},{signal});signal.addEventListener('abort',()=>clearTimeout(loadTimer),{once:true});});
    window.addEventListener('scroll',queue,{passive:true,signal});window.addEventListener('resize',viewportResize,{passive:true,signal});window.visualViewport?.addEventListener('resize',viewportResize,{passive:true,signal});window.addEventListener('orientationchange',scheduleMeasure,{signal});window.addEventListener('pageshow',measure,{signal});reduced.addEventListener('change',measure,{signal});window.addEventListener('beforeprint',()=>scenes.forEach(s=>{s.el.inert=false;}),{signal});window.addEventListener('afterprint',measure,{signal});if(document.fonts?.ready)document.fonts.ready.then(()=>{if(root.isConnected)measure();});
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))queue();},{rootMargin:'100px'});observer.observe(root);const photoLoader=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){root.querySelectorAll('[data-uac-photo] img,[data-uac-companion] img').forEach(img=>{img.loading='eager';img.decode?.().catch(()=>{});});photoLoader.disconnect();}},{rootMargin:'900px'});photoLoader.observe(root);measure();select(0);instances.set(root,()=>{if(openDialog){openDialog.close();document.documentElement.style.overflow=previousOverflow;}abort.abort();observer.disconnect();photoLoader.disconnect();cancelAnimationFrame(frame);clearTimeout(resizeTimer);});
  });
  const init=()=>mount(document);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',event=>mount(event.target));document.addEventListener('shopify:section:unload',event=>instances.forEach((destroy,root)=>{if(event.target.contains(root)){destroy();instances.delete(root);}}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-campaign-ribbon"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mounted=new Map();
 function mount(scope){
  scope.querySelectorAll('[data-ura-campaign-ribbon]').forEach(root=>{
   if(mounted.has(root))return;
   const viewport=root.querySelector('[data-ribbon-viewport]');
   const track=root.querySelector('[data-ribbon-track]');
   const set=root.querySelector('[data-ribbon-set]');
   if(!viewport||!track||!set)return;

   const controller=new AbortController(),signal=controller.signal;
   const mobile=matchMedia('(max-width:760px)');
   const fine=matchMedia('(hover:hover) and (pointer:fine)');
   const reduce=matchMedia('(prefers-reduced-motion:reduce)');

   let width=0,offset=0,last=performance.now(),raf=0,inView=false,desktopHolding=false;
   let userTouching=false,pauseUntil=0,scrollIdleTimer=0,mobileSeeded=false;
   let mobileAuto=0,lastAutoWrite=0,suppressClickUntil=0,touchX=0,touchY=0,touchDragged=false;

   const now=()=>performance.now();
   const wrap=value=>{if(width<=0)return value;value%=width;return value<0?value+width:value;};
   const markAuto=()=>{lastAutoWrite=now();};

   const seedMobile=()=>{
    if(!mobile.matches||reduce.matches||width<=0)return;
    track.style.transform='none';
    if(!mobileSeeded){
     mobileAuto=width;
     markAuto();
     viewport.scrollLeft=mobileAuto;
     mobileSeeded=true;
    }else{
     mobileAuto=viewport.scrollLeft;
     if(mobileAuto<width*.18)mobileAuto+=width;
     else if(mobileAuto>width*1.82)mobileAuto-=width;
     markAuto();
     viewport.scrollLeft=mobileAuto;
    }
   };

   const measure=()=>{
    width=set.getBoundingClientRect().width;
    if(mobile.matches)seedMobile();
    else{
     mobileSeeded=false;
     viewport.scrollLeft=0;
     offset=wrap(offset);
     track.style.transform='translate3d('+(-offset)+'px,0,0)';
    }
   };

   const tick=time=>{
    raf=0;
    const dt=Math.min(42,Math.max(0,time-last));last=time;
    if(!reduce.matches&&inView&&!document.hidden&&time>=pauseUntil&&width>0){
     if(mobile.matches){
      if(!userTouching){
       mobileAuto+=18*dt/1000;
       if(mobileAuto>=width*2)mobileAuto-=width;
       else if(mobileAuto<=0)mobileAuto+=width;
       markAuto();
       viewport.scrollLeft=mobileAuto;
      }
     }else if(!desktopHolding){
      offset=wrap(offset+19*dt/1000);
      track.style.transform='translate3d('+(-offset)+'px,0,0)';
     }
    }
    raf=requestAnimationFrame(tick);
   };

   const ensure=()=>{if(!raf){last=now();raf=requestAnimationFrame(tick);}};

   const observer=new IntersectionObserver(entries=>{
    const e=entries[0];
    inView=Boolean(e?.isIntersecting&&e.intersectionRatio>=.08);
    ensure();
   },{threshold:[0,.08,.35]});
   observer.observe(root);

   const resize=new ResizeObserver(measure);resize.observe(set);measure();

   viewport.addEventListener('touchstart',event=>{
    if(!mobile.matches)return;
    userTouching=true;touchDragged=false;
    touchX=event.touches[0]?.clientX||0;touchY=event.touches[0]?.clientY||0;
    pauseUntil=Infinity;clearTimeout(scrollIdleTimer);
   },{signal,passive:true});

   viewport.addEventListener('touchmove',event=>{
    if(!mobile.matches||!userTouching)return;
    const t=event.touches[0];if(!t)return;
    const dx=Math.abs(t.clientX-touchX),dy=Math.abs(t.clientY-touchY);
    if(dx>8&&dx>dy*.8)touchDragged=true;
   },{signal,passive:true});

   viewport.addEventListener('touchend',()=>{
    if(!mobile.matches)return;
    userTouching=false;
    if(touchDragged)suppressClickUntil=now()+420;
    mobileAuto=viewport.scrollLeft;
    pauseUntil=now()+850;
    clearTimeout(scrollIdleTimer);
    scrollIdleTimer=setTimeout(()=>{if(!userTouching){seedMobile();pauseUntil=now()+180;}},520);
   },{signal,passive:true});

   viewport.addEventListener('touchcancel',()=>{
    if(!mobile.matches)return;
    userTouching=false;mobileAuto=viewport.scrollLeft;pauseUntil=now()+650;
   },{signal,passive:true});

   viewport.addEventListener('scroll',()=>{
    if(!mobile.matches)return;
    if(now()-lastAutoWrite<95)return;
    mobileAuto=viewport.scrollLeft;
    pauseUntil=now()+760;
    clearTimeout(scrollIdleTimer);
    scrollIdleTimer=setTimeout(()=>{if(!userTouching){seedMobile();pauseUntil=now()+180;}},500);
   },{signal,passive:true});

   viewport.addEventListener('click',event=>{
    if(now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}
   },{signal,capture:true});

   root.addEventListener('pointerenter',()=>{if(fine.matches&&!mobile.matches)desktopHolding=true;},{signal,passive:true});
   root.addEventListener('pointerleave',()=>{if(fine.matches&&!mobile.matches){desktopHolding=false;pauseUntil=now()+650;}},{signal,passive:true});

   document.addEventListener('visibilitychange',()=>{last=now();},{signal});
   mobile.addEventListener('change',()=>{mobileSeeded=false;pauseUntil=now()+250;measure();last=now();},{signal});
   reduce.addEventListener('change',()=>{
    mobileSeeded=false;offset=0;
    if(reduce.matches){track.style.transform='';viewport.scrollLeft=0;}
    else measure();
    last=now();
   },{signal});

   ensure();
   mounted.set(root,()=>{controller.abort();observer.disconnect();resize.disconnect();clearTimeout(scrollIdleTimer);if(raf)cancelAnimationFrame(raf);});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [root,cleanup] of mounted){if(event.target.contains(root)){cleanup();mounted.delete(root);}}});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-card-identity"] && !Shopify.designMode) return;
  try {
    (function(){
 if(window.__uraDisclosure0921)return;
 window.__uraDisclosure0921=true;
 var selector='[data-ura-hover-disclosure]',active=null,states=new WeakMap(),frame=0;
 function state(panel){
  if(!states.has(panel))states.set(panel,{pinned:false,hovered:false,suppressFocus:false,leaveTimer:0});
  return states.get(panel);
 }
 function place(panel){
  if(!panel||!panel.open)return;
  var box=panel.querySelector('.ura-tech__panel');
  if(!box)return;
  box.style.setProperty('--ura-disclosure-x','0px');
  panel.removeAttribute('data-panel-side');
  var visual=window.visualViewport,viewportWidth=visual?visual.width:document.documentElement.clientWidth;
  var viewportLeft=visual?visual.offsetLeft:0,viewportTop=visual?visual.offsetTop:0;
  var viewportBottom=viewportTop+(visual?visual.height:innerHeight);
  var anchor=panel.querySelector('summary').getBoundingClientRect();
  var below=viewportBottom-anchor.bottom-20,above=anchor.top-viewportTop-20;
  if(below<Math.min(box.scrollHeight,300)&&above>below)panel.dataset.panelSide='above';
  var available=panel.dataset.panelSide==='above'?above:below;
  box.style.maxHeight=Math.max(120,Math.min(380,available))+'px';
  var rect=box.getBoundingClientRect(),shift=0;
  if(rect.right>viewportLeft+viewportWidth-12)shift=viewportLeft+viewportWidth-12-rect.right;
  if(rect.left+shift<viewportLeft+12)shift+=viewportLeft+12-(rect.left+shift);
  box.style.setProperty('--ura-disclosure-x',shift+'px');
 }
 function close(panel,restore){
  if(!panel)return;
  var s=state(panel);clearTimeout(s.leaveTimer);s.pinned=false;s.hovered=false;s.suppressFocus=true;
  panel.open=false;if(active===panel)active=null;
  if(restore)panel.querySelector('summary').focus({preventScroll:true});
  queueMicrotask(function(){s.suppressFocus=false;});
 }
 function open(panel){
  if(active&&active!==panel)close(active,false);
  clearTimeout(state(panel).leaveTimer);active=panel;panel.open=true;
  requestAnimationFrame(function(){place(panel);});
 }
 function panelFor(target){return target instanceof Element?target.closest(selector):null;}
 document.addEventListener('pointerover',function(e){
  if(e.pointerType!=='mouse'||!matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  var panel=panelFor(e.target);if(!panel||panel.contains(e.relatedTarget))return;
  state(panel).hovered=true;open(panel);
 });
 document.addEventListener('pointerout',function(e){
  var panel=panelFor(e.target);if(!panel||panel.contains(e.relatedTarget))return;
  var s=state(panel);s.hovered=false;clearTimeout(s.leaveTimer);
  s.leaveTimer=setTimeout(function(){if(!s.pinned&&!panel.contains(document.activeElement))close(panel,false);},120);
 });
 document.addEventListener('focusin',function(e){
  var panel=panelFor(e.target);
  if(active&&active!==panel)close(active,false);
  if(panel&&!state(panel).suppressFocus)open(panel);
 });
 document.addEventListener('focusout',function(e){
  var panel=panelFor(e.target);if(!panel)return;
  setTimeout(function(){if(!panel.contains(document.activeElement)&&!state(panel).hovered)close(panel,false);},0);
 });
 document.addEventListener('click',function(e){
  var summary=e.target instanceof Element?e.target.closest('summary'):null;
  var panel=summary&&summary.parentElement.matches(selector)?summary.parentElement:null;
  if(!panel)return;
  e.preventDefault();e.stopPropagation();
  var s=state(panel);if(s.pinned)close(panel,false);else{s.pinned=true;open(panel);}
 });
 document.addEventListener('pointerdown',function(e){if(active&&!active.contains(e.target))close(active,false);});
 document.addEventListener('keydown',function(e){
  if(e.key==='Escape'&&active){e.preventDefault();e.stopPropagation();close(active,true);}
 });
 function schedule(){if(!active||frame)return;frame=requestAnimationFrame(function(){frame=0;place(active);});}
 addEventListener('resize',schedule,{passive:true});
 addEventListener('scroll',schedule,{passive:true,capture:true});
 if(window.visualViewport){visualViewport.addEventListener('resize',schedule,{passive:true});visualViewport.addEventListener('scroll',schedule,{passive:true});}
 document.addEventListener('load',function(e){if(active&&active.contains(e.target))schedule();},true);
 document.addEventListener('shopify:section:unload',function(e){if(active&&e.target.contains(active))close(active,false);});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-commerce-experience"] && !Shopify.designMode) return;
  try {
    (()=>{
 const enhance=()=>{
  document.querySelectorAll('[data-ura4-product] .ura4-record__grid').forEach(grid=>{
   if(grid.dataset.foldsReady)return;grid.dataset.foldsReady='true';
   Array.from(grid.children).forEach((panel,index)=>{
    const heading=panel.querySelector('h3');if(!heading)return;
    const details=document.createElement('details');details.className='ura-record-fold';details.open=true;
    const summary=document.createElement('summary');summary.textContent=heading.textContent;if(heading.id){summary.id=heading.id;heading.removeAttribute('id')}heading.remove();
    panel.before(details);details.append(summary,panel);
   });
  });
  const reveal=()=>{
   if(!location.hash)return;
   const target=document.getElementById(decodeURIComponent(location.hash.slice(1)));
   const fold=target?.closest('.ura-record-fold');if(fold){fold.open=true;requestAnimationFrame(()=>target.scrollIntoView({block:'start'}))}
  };
  document.querySelectorAll('.ura4-record__nav a').forEach(a=>a.addEventListener('click',()=>{const target=document.getElementById(a.hash.slice(1));const fold=target?.closest('details');if(fold)fold.open=true}));
  window.addEventListener('hashchange',reveal);reveal();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance);else enhance();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-editorial-experience"] && !Shopify.designMode) return;
  try {
    (()=>{
  const mounted=new Map();
  const reduce=matchMedia('(prefers-reduced-motion:reduce)');
  const narrow=matchMedia('(max-width:760px)');
  const pointer=matchMedia('(hover:hover) and (pointer:fine)');
  const mount=scope=>scope.querySelectorAll('[data-ue-page]').forEach(root=>{
    if(mounted.has(root))return;
    const events=new AbortController(),signal=events.signal;
    const header=document.querySelector('.ura-header');
    const toc=root.querySelector('[data-ue-toc]'),tocLinks=root.querySelector('[data-ue-toc-links]');
    const documentBody=root.querySelector('[data-ue-document]');
    if(toc&&documentBody){
      const headings=[...documentBody.querySelectorAll('h2')];
      toc.hidden=!headings.length;
      headings.forEach((heading,index)=>{
        if(!heading.id){let id='UraDocumentChapter-'+(index+1);while(document.getElementById(id))id+='-section';heading.id=id;}
        heading.dataset.ueChapter='';
        const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;link.dataset.ueNav='';tocLinks.appendChild(link);
      });
      const setToc=()=>{toc.open=!narrow.matches;};setToc();narrow.addEventListener('change',setToc,{signal});
      tocLinks.addEventListener('click',event=>{if(event.target.closest('a')&&narrow.matches)toc.open=false;},{signal});
    }
    const chapters=[...root.querySelectorAll('[data-ue-chapter]')];
    const links=[...root.querySelectorAll('[data-ue-nav]')];
    const hero=root.querySelector('[data-ue-hero]');
    let frame=0,active='';
    const clamp=value=>Math.max(0,Math.min(1,value));
    const paint=()=>{
      frame=0;
      const top=Math.max(0,Math.min(150,header?.getBoundingClientRect().bottom||80));
      root.style.setProperty('--ue-sticky-top',Math.round(top)+'px');
      const box=root.getBoundingClientRect();
      root.style.setProperty('--ue-progress',String(clamp((top-box.top)/Math.max(1,box.height-innerHeight+top))));
      if(hero){const r=hero.getBoundingClientRect();root.style.setProperty('--ue-hero',String(reduce.matches?1:clamp(.55+(top-r.top)/Math.max(300,r.height))));}
      let current=chapters[0]?.id||'';
      chapters.forEach(chapter=>{if(chapter.getBoundingClientRect().top<=top+160)current=chapter.id;});
      if(current!==active){active=current;links.forEach(link=>{if(link.hash.slice(1)===current)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});}
    };
    const queue=()=>{if(!frame)frame=requestAnimationFrame(paint);};
    addEventListener('scroll',queue,{passive:true,signal});addEventListener('resize',queue,{passive:true,signal});
    const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ue-in-view');observer.unobserve(entry.target);}});},{threshold:.08}):null;
    if(observer){root.classList.add('ue-motion');root.querySelectorAll('[data-ue-reveal]').forEach(el=>observer.observe(el));}
    root.querySelectorAll('[data-ue-magnet]').forEach(el=>{
      const reset=()=>{el.style.setProperty('--ue-mx','0px');el.style.setProperty('--ue-my','0px');};
      el.addEventListener('pointermove',event=>{if(reduce.matches||!pointer.matches||event.pointerType!=='mouse')return;const r=el.getBoundingClientRect();el.style.setProperty('--ue-mx',Math.max(-4,Math.min(4,(event.clientX-r.left-r.width/2)*.045))+'px');el.style.setProperty('--ue-my',Math.max(-3,Math.min(3,(event.clientY-r.top-r.height/2)*.075))+'px');},{signal});
      el.addEventListener('pointerleave',reset,{signal});el.addEventListener('blur',reset,{signal});reduce.addEventListener('change',reset,{signal});
    });
    root.querySelector('[data-ura-contact-chat]')?.addEventListener('click',async event=>{
      const note=root.querySelector('[data-ura-contact-chat-status]');
      const fallback=event.currentTarget.dataset.chatFallback;
      const waitForModernChat=()=>new Promise(resolve=>{
        const existing=document.querySelector('shopify-chat');
        if(existing){resolve(existing);return;}
        let settled=false;
        const finish=value=>{if(settled)return;settled=true;observer.disconnect();clearTimeout(timer);resolve(value);};
        const observer=new MutationObserver(()=>{const host=document.querySelector('shopify-chat');if(host)finish(host);});
        observer.observe(document.documentElement,{childList:true,subtree:true});
        const timer=setTimeout(()=>finish(null),3000);
      });
      let host=document.querySelector('shopify-chat')||await waitForModernChat();
      if(host){
        try{
          await Promise.race([
            customElements.whenDefined('shopify-chat'),
            new Promise(resolve=>setTimeout(resolve,1800))
          ]);
        }catch(e){}
        try{
          if(typeof host.show==='function')host.show();
          else host.setAttribute('open','');
          return;
        }catch(e){}
      }
      const legacy=document.querySelector('inbox-online-store-chat,#ShopifyChat');
      const launcher=legacy?.shadowRoot?.querySelector('button.chat-toggle,button[part~="activator"]');
      if(launcher){launcher.click();return;}
      if(note)note.textContent=fallback;
    },{signal});
    root.querySelectorAll('.ura-contact__form').forEach(form=>{
      if(form.dataset.validationReady)return;form.dataset.validationReady='true';
      const fields=[...form.querySelectorAll('input[required],select[required],textarea[required]')];
      fields.forEach(field=>{
        const previous=field.getAttribute('aria-describedby')||'';
        const error=document.createElement('p');error.id=field.id+'-error';error.className='ura-contact__field-error';error.hidden=true;field.after(error);
        const update=()=>{const bad=!field.validity.valid;field.setAttribute('aria-invalid',String(bad));error.textContent=bad?field.validationMessage:'';error.hidden=!bad;const ids=[previous,bad?error.id:''].filter(Boolean).join(' ');if(ids)field.setAttribute('aria-describedby',ids);else field.removeAttribute('aria-describedby');};
        field.addEventListener('invalid',update,{signal});field.addEventListener('blur',()=>{if(field.value||field.getAttribute('aria-invalid')==='true')update();},{signal});field.addEventListener('input',()=>{if(field.getAttribute('aria-invalid')==='true')update();},{signal});field.addEventListener('change',()=>{if(field.getAttribute('aria-invalid')==='true')update();},{signal});
      });
      let resetTimer=0;const reset=()=>{clearTimeout(resetTimer);form.removeAttribute('aria-busy');const button=form.querySelector('button[type="submit"]');if(button)button.disabled=false;};
      form.addEventListener('submit',()=>{form.setAttribute('aria-busy','true');form.querySelector('button[type="submit"]').disabled=true;resetTimer=setTimeout(reset,12000);},{signal});addEventListener('pageshow',reset,{signal});
      form.querySelector('[data-ue-form-status]')?.focus();
      signal.addEventListener('abort',()=>{reset();delete form.dataset.validationReady;});
    });
    const resize=new ResizeObserver(queue);resize.observe(root);reduce.addEventListener('change',queue,{signal});paint();
    mounted.set(root,()=>{events.abort();observer?.disconnect();resize.disconnect();cancelAnimationFrame(frame);mounted.delete(root);});
  });
  const init=()=>mount(document);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>mounted.forEach((destroy,root)=>{if(event.target.contains(root))destroy();}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-era-shell-1016"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>{if(document.body.dataset.eraShellReady)return;document.body.dataset.eraShellReady='true';const bind=(dialog,buttons)=>{if(!dialog)return;let opener;buttons.forEach(button=>button.addEventListener('click',()=>{opener=button;dialog.showModal();buttons.forEach(b=>b.setAttribute('aria-expanded','true'));if(button.hasAttribute('data-era-search-open'))dialog.querySelector('input[type=search]')?.focus()}));dialog.querySelector('[data-era-close]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{buttons.forEach(b=>b.setAttribute('aria-expanded','false'));opener?.focus({preventScroll:true})});dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()})};bind(document.getElementById('EraMenu'),document.querySelectorAll('[data-era-menu-open]'));bind(document.getElementById('EraRegion'),document.querySelectorAll('[data-era-region-open]'));const mobile=matchMedia('(max-width:760px)'),groups=document.querySelectorAll('.era-footer__group');const adapt=()=>groups.forEach(group=>{group.open=!mobile.matches});adapt();mobile.addEventListener('change',adapt);const edit=document.getElementById('TheEdit'),tabs=document.querySelectorAll('[data-era-app]');if(edit&&'IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{const inEdit=entries[0].isIntersecting;tabs.forEach(link=>{if(link.dataset.eraApp===(inEdit?'edit':'home'))link.setAttribute('aria-current','location');else link.removeAttribute('aria-current')})},{rootMargin:'-60px 0px -35% 0px'});observer.observe(edit)}};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-fit-page-cinema"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    if (root.dataset.ufcReady) return;
    root.dataset.ufcReady = 'true';
    const method = root.querySelector('.ufc-method');
    const drawing = method.querySelector('[data-ura-fit-blueprint]');
    const trace = drawing.querySelector('[data-ura-fit-trace]');
    const chapters = Array.from(method.querySelectorAll('[data-ufc-step]'));
    const count = method.querySelector('[data-ufc-count]');
    const caption = method.querySelector('[data-ufc-caption]');
    const categories = Array.from(root.closest('.ufr-cinema').querySelectorAll('[data-ufe-category]'));
    categories.forEach(category => {
      const manual = event => { if (event.target.closest('button,a,input,select')) category.dataset.ufcManual = 'true'; };
      category.addEventListener('pointerdown', manual);
      category.addEventListener('focusin', manual);
    });
    const compact = matchMedia('(max-width:1023px), (max-height:600px)');
    const inlineDrawings = Array.from(method.querySelectorAll('[data-ufc-inline]'));
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const short = matchMedia('(max-height:329px)');
    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    let frame = 0;
    let current = -1;
    let widthPath = '';
    let lengthPath = '';
    const choose = (index) => {
      if (!window.URAFitBlueprint) return false;
      const key = chapters[index].dataset.ufcStep;
      method.dataset.ufcActiveStep = key;
      if (!widthPath) {
        window.URAFitBlueprint.activate(drawing, 'width', false);
        widthPath = trace.getAttribute('d');
        window.URAFitBlueprint.activate(drawing, 'length', false);
        lengthPath = trace.getAttribute('d');
      }
      window.URAFitBlueprint.activate(drawing, key === 'compare' ? 'length' : key, false);
      if (key === 'compare') {
        trace.setAttribute('d', widthPath + ' ' + lengthPath);
        drawing.querySelectorAll('[data-ura-fit-start],[data-ura-fit-end]').forEach(node => node.setAttribute('visibility', 'hidden'));
      }
      count.textContent = String(index + 1).padStart(2, '0');
      caption.textContent = chapters[index].dataset.ufcLabel;
      chapters.forEach((chapter, chapterIndex) => chapter.classList.toggle('is-active', chapterIndex === index));
      current = index;
      return true;
    };
    method.addEventListener('ura:fit-practice', event => {
      const index = chapters.findIndex(chapter => chapter.dataset.ufcStep === event.detail.measure);
      if (index < 0) return;
      choose(index);
      method.style.setProperty('--ufc-draw', '0');
    });
    const update = () => {
      frame = 0;
      if (!root.isConnected) return;
      if (window.URAFitBlueprint) inlineDrawings.forEach(wrapper => {
        if (wrapper.dataset.ufcInlineReady) return;
        window.URAFitBlueprint.activate(wrapper.querySelector('[data-ura-fit-blueprint]'), wrapper.dataset.ufcInline, false);
        wrapper.dataset.ufcInlineReady = 'true';
      });
      const passive = reduced.matches || short.matches;
      const box = method.getBoundingClientRect();
      if (box.bottom >= 0 && box.top <= innerHeight) {
      const focus = compact.matches ? innerHeight * .67 : innerHeight * .48;
      let index = 0;
      let distance = Infinity;
      chapters.forEach((chapter, i) => {
        const rect = chapter.getBoundingClientRect();
        const point = compact.matches ? rect.top + 80 : rect.top + rect.height * .45;
        const gap = Math.abs(point - focus);
        if (gap < distance) { distance = gap; index = i; }
      });
      if (passive) index = 3;
      if (current !== index) choose(index);
      const active = chapters[index].getBoundingClientRect();
      const progress = passive ? 1 : clamp((focus - active.top + active.height * .08) / (active.height * .58));
      method.style.setProperty('--ufc-progress', String((index + progress) / chapters.length));
      method.style.setProperty('--ufc-draw', String(1 - progress));
      }
      categories.forEach(category => {
        const rect = category.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > innerHeight) return;
        const progress = passive ? 1 : clamp((innerHeight * .72 - rect.top) / Math.max(rect.height * .68, 1));
        category.style.setProperty('--ufc-category-progress', String(progress));
        if (category.dataset.ufcManual || passive || !window.URAFitBlueprint) return;
        const diagram = category.querySelector('[data-ura-fit-blueprint]');
        const measure = progress < .48 ? 'width' : 'length';
        if (diagram && category.dataset.ufcMeasure !== measure) {
          category.dataset.ufcMeasure = measure;
          window.URAFitBlueprint.activate(diagram, measure, true);
        }
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    reduced.addEventListener('change', () => { current = -1; schedule(); });
    short.addEventListener('change', () => { current = -1; schedule(); });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      removeEventListener('scroll', schedule);
      removeEventListener('resize', schedule);
      cancelAnimationFrame(frame);
    });
    schedule();
    addEventListener('load', schedule, { once: true });
  };
  const ready = () => document.querySelectorAll('[data-ufc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  document.addEventListener('shopify:section:load', ready);
})();

(() => {
  const mounted = new Map();
  const mount = scope => {
    const roots = scope.matches?.('.ufr-cinema') ? [scope] : scope.querySelectorAll('.ufr-cinema');
    roots.forEach(root => {
      if (mounted.has(root) || !('IntersectionObserver' in window)) return;
      const mobile = matchMedia('(max-width:760px),(max-width:1023px) and (pointer:coarse)');
      const targets = Array.from(root.querySelectorAll('[data-ura-fit-blueprint], .ufc-method__instrument'));
      const visible = new Map();
      const paint = () => root.toggleAttribute('data-ura-fit-art-in-view', root.isConnected && mobile.matches && Array.from(visible.values()).some(Boolean));
      const refresh = () => {
        targets.forEach(target => {
          const box = target.getBoundingClientRect();
          visible.set(target, box.width > 0 && box.height > 0 && box.top < innerHeight && box.bottom > 0 && box.left < innerWidth && box.right > 0);
        });
        paint();
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => visible.set(entry.target, entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0));
        paint();
      });
      targets.forEach(target => observer.observe(target));
      mobile.addEventListener('change', refresh);
      addEventListener('pageshow', refresh);
      addEventListener('resize', refresh, { passive: true });
      refresh();
      mounted.set(root, () => {
        observer.disconnect();
        mobile.removeEventListener('change', refresh);
        removeEventListener('pageshow', refresh);
        removeEventListener('resize', refresh);
        root.removeAttribute('data-ura-fit-art-in-view');
        mounted.delete(root);
      });
    });
  };
  const ready = () => mount(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => mounted.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); }));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-fit-page-practice"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = () => document.querySelectorAll('.ufr-cinema .ufc-method').forEach(method => {
    const nodes = Array.from(method.querySelectorAll('[data-ufp-practice]'));
    if (!nodes.length || method.dataset.ufpReady) return;
    method.dataset.ufpReady = 'true';
    const abort = new AbortController();
    const listen = (node, type, fn, options = {}) => node.addEventListener(type, fn, {...options, signal:abort.signal});
    const arabic = document.documentElement.lang.split('-')[0] === 'ar';
    let unit = 'in';
    const tapeSpanCm = 12.7;
    const scale = () => unit === 'in' ? 2.54 : 1;
    const label = () => arabic ? (unit === 'in' ? 'بوصة' : 'سم') : unit;
    const items = nodes.map(root => ({root,cm:Number(root.dataset.start),min:Number(root.dataset.min),max:Number(root.dataset.max),range:root.querySelector('[data-ufp-range]'),number:root.querySelector('[data-ufp-number]'),surface:root.querySelector('.ura4-fit__slider'),rail:root.querySelector('.ura4-fit__rail'),ruler:root.querySelector('.ura4-fit__ruler'),control:root.querySelector('.ura4-fit__control')}));
    const activate = item => method.dispatchEvent(new CustomEvent('ura:fit-practice',{detail:{measure:item.root.dataset.ufpPractice}}));
    function sync(item) {
      const value = item.cm / scale();
      item.range.value = String(value);
      item.range.setAttribute('aria-valuetext',value.toFixed(1)+' '+label());
      item.number.value = value.toFixed(1);
      item.root.querySelector('[data-ufp-unit-label]').textContent = label();
      item.rail.style.setProperty('--ura4-position','50%');
      item.rail.style.setProperty('--ura4-tape-offset',(50-(item.cm-item.min)/tapeSpanCm*100)+'%');
    }
    function set(item,value) {
      if (!Number.isFinite(value)) { sync(item); return; }
      item.cm = Math.max(item.min,Math.min(item.max,value));
      sync(item); activate(item);
    }
    function draw(item) {
      const min = item.min / scale(), max = item.max / scale();
      item.range.min = String(min); item.range.max = String(max); item.range.step = 'any';
      item.number.min = (Math.ceil(min*10)/10).toFixed(1); item.number.max = (Math.floor(max*10)/10).toFixed(1);
      const span = tapeSpanCm / scale();
      const increment = unit === 'in' ? .125 : .5;
      const every = unit === 'in' ? 8 : 10;
      const fragment = document.createDocumentFragment();
      for(let index=Math.ceil(Math.max(0,min-span/2)/increment);index<=Math.floor((max+span/2)/increment);index++) {
        const major=index%every===0;
        const tick=document.createElement('span');
        tick.className='ura4-fit__tick'+(major?' is-major':index%2===0?' is-mid':'')+(index*increment<min||index*increment>max?' is-outside':'');
        tick.style.left=((index*increment-min)/span*100)+'%';
        if(major){const text=document.createElement('b');text.textContent=String(Math.round(index*increment));tick.append(text);}
        fragment.append(tick);
      }
      item.ruler.replaceChildren(fragment);
      item.root.querySelectorAll('[data-ufp-unit]').forEach(button=>{const active=button.dataset.ufpUnit===unit;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));if(arabic)button.textContent=button.dataset.ufpUnit==='in'?'بوصة':'سم';});
      sync(item);
    }
    items.forEach(item=>{
      let drag=null;
      const finish=(event,cancelled)=>{
        if(!drag || drag.id!==event.pointerId)return;
        const previous=drag;drag=null;item.control.classList.remove('is-dragging');
        if(item.surface.hasPointerCapture(previous.id))item.surface.releasePointerCapture(previous.id);
        if(cancelled)return;
        if(!previous.moved){const bounds=item.rail.getBoundingClientRect();set(item,item.cm+(event.clientX-bounds.left-bounds.width/2)/Math.max(1,bounds.width)*tapeSpanCm);}
        if(item.cm>item.min&&item.cm<item.max)set(item,Math.round(item.cm/scale()*10)/10*scale());
      };
      item.surface.classList.add('is-tape-ready');
      listen(item.surface,'pointerdown',event=>{
        if(!event.isPrimary||event.button!==0)return;
        item.range.focus({preventScroll:true});activate(item);
        drag={id:event.pointerId,x:event.clientX,y:event.clientY,cm:item.cm,width:Math.max(1,item.rail.getBoundingClientRect().width),moved:false};
        item.surface.setPointerCapture(event.pointerId);
        if(event.pointerType==='mouse')event.preventDefault();
      });
      listen(item.surface,'pointermove',event=>{
        if(!drag||drag.id!==event.pointerId)return;
        const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
        if(!drag.moved){if(Math.abs(dy)>7&&Math.abs(dy)>Math.abs(dx)){finish(event,true);return;}if(Math.abs(dx)<4)return;drag.moved=true;item.control.classList.add('is-dragging');}
        if(event.cancelable)event.preventDefault();
        set(item,drag.cm-dx/drag.width*tapeSpanCm);
      });
      listen(item.surface,'pointerup',event=>finish(event,false));
      listen(item.surface,'pointercancel',event=>finish(event,true));
      listen(item.surface,'lostpointercapture',event=>finish(event,true));
      listen(item.range,'input',()=>set(item,Number(item.range.value)*scale()));
      listen(item.range,'focus',()=>activate(item));
      listen(item.range,'keydown',event=>{
        let value=item.cm/scale();
        if(event.key==='ArrowRight'||event.key==='ArrowUp')value+=.1;
        else if(event.key==='ArrowLeft'||event.key==='ArrowDown')value-=.1;
        else if(event.key==='PageUp')value+=1;
        else if(event.key==='PageDown')value-=1;
        else if(event.key==='Home')value=item.min/scale();
        else if(event.key==='End')value=item.max/scale();else return;
        event.preventDefault();set(item,value*scale());
      });
      listen(item.number,'focus',()=>activate(item));
      listen(item.number,'input',()=>{const value=item.number.valueAsNumber;if(Number.isFinite(value)&&value*scale()>=item.min&&value*scale()<=item.max){item.cm=value*scale();item.range.value=String(value);item.range.setAttribute('aria-valuetext',value.toFixed(1)+' '+label());item.rail.style.setProperty('--ura4-tape-offset',(50-(item.cm-item.min)/tapeSpanCm*100)+'%');activate(item);}});
      listen(item.number,'change',()=>set(item,item.number.valueAsNumber*scale()));
      item.root.querySelectorAll('[data-ufp-unit]').forEach(button=>listen(button,'click',()=>{unit=button.dataset.ufpUnit;items.forEach(draw);activate(item);}));
      draw(item);
    });
    listen(document,'shopify:section:unload',event=>{if(event.target.contains(method)){abort.abort();delete method.dataset.ufpReady;}});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});else mount();
  document.addEventListener('shopify:section:load',mount);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-fit-reference-guide"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(guide){
    if(guide.dataset.ufrgReady)return;
    guide.dataset.ufrgReady='true';
    var context=guide.dataset.ufrgContext;
    if(context==='page')return;
    var scope=context==='home'?guide.closest('.uhr-fit'):context==='category'?guide.closest('[data-ufe-category]'):guide.closest('[data-ura4-product]');
    if(!scope)return;
    var controls=Array.from(guide.querySelectorAll('[data-ufrg-step]'));
    var selected='flat';
    var hover=window.matchMedia('(hover:hover) and (pointer:fine)');
    var mobile=window.matchMedia('(max-width:749px)');
    var homeTitle=context==='home'&&scope.querySelector('.ura-fit-intro__copy h2');
    if(homeTitle)homeTitle.insertAdjacentElement('afterend',guide);
    var anchor=document.createTextNode('');guide.before(anchor);
    var help=context==='product'?guide.closest('.ura-fit-help'):null;
    function blueprint(){return scope.querySelector('[data-ura-fit-blueprint]')}
    function sync(measure){
      selected=['flat','width','length'].includes(measure)?measure:'flat';
      var drawing=blueprint();
      var kind=drawing&&drawing.getAttribute('data-ura-fit-kind')||'';
      var bottom=/trousers|pants|jeans|shorts/.test(kind);
      guide.querySelectorAll('[data-top][data-bottom]').forEach(function(node){node.textContent=bottom?node.dataset.bottom:node.dataset.top});
      controls.forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.ufrgStep===selected))});
      guide.querySelectorAll('[data-ufrg-caption]').forEach(function(p){p.hidden=p.dataset.ufrgCaption!==selected});
      if(drawing)drawing.setAttribute('data-ufrg-linked','true');
    }
    function choose(measure){
      scope.dispatchEvent(new CustomEvent('ura:measure-guide',{detail:{measure:measure}}));
      var drawing=blueprint();
      if(drawing&&window.URAFitBlueprint)window.URAFitBlueprint.activate(drawing,measure,true);
      sync(measure);
    }
    controls.forEach(function(button){
      button.addEventListener('click',function(){choose(button.dataset.ufrgStep)});
      button.addEventListener('pointerenter',function(e){
        if(context==='home'&&scope.querySelector('[data-ufe-story-managed]:not([data-ufe-story-manual])'))return;
        if(hover.matches&&e.pointerType==='mouse')choose(button.dataset.ufrgStep);
      });
      button.addEventListener('focus',function(){choose(button.dataset.ufrgStep)});
    });
    scope.addEventListener('ura:fit-measure',function(event){if(event.target===blueprint())sync(event.detail.measure)});
    function place(){
      var destination=context==='home'?scope.querySelector('[data-ufe-host]'):context==='product'?scope.querySelector('.ura4-fit__workspace'):scope.querySelector('.ufe-guide');
      if(mobile.matches&&destination&&!(help&&help.tagName==='DETAILS')){destination.before(guide);guide.dataset.ufrgMobile='true';if(help)help.classList.add('is-guide-relocated')}
      else{anchor.after(guide);delete guide.dataset.ufrgMobile;if(help)help.classList.remove('is-guide-relocated')}
    }
    mobile.addEventListener('change',place);place();
    var drawing=blueprint();
    if(drawing&&window.URAFitBlueprint)window.URAFitBlueprint.activate(drawing,'flat',false);
    sync('flat');
  }
  function ready(){document.querySelectorAll('[data-ufrg]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  document.addEventListener('shopify:section:load',ready);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-garment-blueprint"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var paths = {
      tshirt: {
        width: 'M 266.95 509.71 L 733.05 509.71',
        length: 'M 43 212.63 L 43 971.38',
        shoulder: 'M 231.4 146.54 L 768.6 146.54'
      },
      polo: {
        width: 'M 266.95 500.72 L 733.05 500.72',
        length: 'M 43 170.38 L 43 1014.08',
        shoulder: 'M 231.4 101.6 L 768.6 101.6'
      },
      sweatshirt: {
        width: 'M 266.95 512.61 L 733.05 512.61',
        length: 'M 43 207.13 L 43 976.95',
        shoulder: 'M 231.4 140.69 L 768.6 140.69'
      },
      hoodie: {
        width: 'M 282.75 535.23 L 717.25 535.23',
        length: 'M 43 316.17 L 43 1023.57',
        shoulder: 'M 239.3 91.61 L 760.7 91.61'
      },
      'zip-hoodie': {
        width: 'M 282.75 535.75 L 717.25 535.75',
        length: 'M 43 318.74 L 43 1019.49',
        shoulder: 'M 239.3 95.9 L 760.7 95.9'
      },
      jacket: {
        width: 'M 266.95 512.73 L 733.05 512.73',
        length: 'M 43 207.71 L 43 976.35',
        shoulder: 'M 231.4 141.31 L 768.6 141.31'
      },
      trousers: {
        width: 'M 311.65 135 L 688.35 135',
        hip: 'M 281.04 335 L 718.96 335',
        length: 'M 202.56 135 L 202.56 1085'
      },
      jeans: {
        width: 'M 312.26 135 L 687.74 135',
        hip: 'M 281.75 335 L 718.25 335',
        length: 'M 203.32 135 L 203.32 1085'
      },
      sweatpants: {
        width: 'M 313.22 135 L 686.78 135',
        hip: 'M 282.87 335 L 717.13 335',
        length: 'M 204.53 135 L 204.53 1085'
      },
      shorts: {
        width: 'M 224 248.19 L 776 248.19',
        hip: 'M 179.15 432.89 L 820.85 432.89',
        length: 'M 93 248.19 L 93 936.29'
      }
    };

    var names = {
      tshirt: 'T-SHIRT',
      polo: 'POLO',
      sweatshirt: 'SWEATSHIRT',
      hoodie: 'HOODIE',
      'zip-hoodie': 'ZIP HOODIE',
      jacket: 'JACKET',
      trousers: 'TROUSERS',
      jeans: 'JEANS',
      sweatpants: 'SWEATPANTS',
      shorts: 'SHORTS'
    };

    var namesAr = {
      tshirt: 'تيشيرت',
      polo: 'بولو',
      sweatshirt: 'سويت شيرت',
      hoodie: 'هودي',
      'zip-hoodie': 'هودي بسحّاب',
      jacket: 'جاكيت',
      trousers: 'بنطلون',
      jeans: 'جينز',
      sweatpants: 'بنطلون رياضي',
      shorts: 'شورت'
    };

    function isArabic(root) {
      return String(root.getAttribute('data-ura-fit-locale') || document.documentElement.lang || '').toLowerCase().split('-')[0] === 'ar';
    }

    var bottoms = {
      trousers: true,
      jeans: true,
      sweatpants: true,
      shorts: true
    };

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parse(node) {
      if (!node) return null;
      try {
        return JSON.parse(node.textContent || '');
      } catch (error) {
        return null;
      }
    }

    function contextText(root) {
      var pdp = root.closest('[data-pdp-fit]');
      var record;
      var page;
      var products;
      var handle;

      if (pdp) {
        record = parse(pdp.querySelector('[data-pdp-fit-product]'));
      } else {
        page = root.closest('[data-upf]');
        if (page) {
          products = parse(page.querySelector('[data-upf-products]'));
          handle = page.querySelector('[data-upf-product]') && page.querySelector('[data-upf-product]').value;
          if (Array.isArray(products)) {
            record = products.find(function (item) {
              return item && item.handle === handle;
            });
          }
        }
      }

      if (!record) return '';
      return [
        record.garment,
        record.fit,
        record.productType,
        record.title,
        record.handle
      ].join(' ');
    }

    function classify(value) {
      var text = String(value || '').toLowerCase();
      if ((text.indexOf('zip') > -1 && text.indexOf('hood') > -1) || text.indexOf('zip-up') > -1) return 'zip-hoodie';
      if (text.indexOf('hood') > -1) return 'hoodie';
      if (text.indexOf('sweatshirt') > -1 || text.indexOf('crewneck') > -1) return 'sweatshirt';
      if (text.indexOf('polo') > -1) return 'polo';
      if (text.indexOf('jacket') > -1 || text.indexOf('overshirt') > -1 || text.indexOf('coat') > -1 || text.indexOf('parka') > -1 || text.indexOf('blazer') > -1) return 'jacket';
      if (text.indexOf('jean') > -1 || text.indexOf('denim') > -1) return 'jeans';
      if (text.indexOf('sweatpant') > -1 || text.indexOf('jogger') > -1) return 'sweatpants';
      if (text.indexOf('shorts') > -1) return 'shorts';
      if (text.indexOf('trouser') > -1 || text.indexOf('chino') > -1 || text.indexOf('pants') > -1) return 'trousers';
      return 'tshirt';
    }

    function kindFor(root) {
      return classify((root.getAttribute('data-garment-type') || '') + ' ' + contextText(root));
    }

    function measurementLabel(kind, measure, root) {
      if (isArabic(root)) {
        if (measure === 'width') return bottoms[kind] ? 'عرض الخصر' : 'عرض الصدر';
        if (measure === 'length') return 'طول القطعة';
        if (measure === 'shoulder') return 'عرض الكتفين';
        if (measure === 'hip') return 'عرض الورك';
        return 'القياس';
      }
      if (measure === 'width') return bottoms[kind] ? 'WAIST WIDTH' : 'CHEST WIDTH';
      if (measure === 'length') return 'GARMENT LENGTH';
      if (measure === 'shoulder') return 'SHOULDER WIDTH';
      if (measure === 'hip') return 'HIP WIDTH';
      return 'MEASUREMENT';
    }

    function setKind(root, value) {
      var kind = paths[value] ? value : classify(value);
      var image = root.querySelector('[data-ura-fit-blueprint-image]');
      var heading = root.querySelector('[data-garment-blueprint-label]');
      var widthLabel = root.querySelector('[data-ura-demo-width-label]');
      var arabic = isArabic(root);
      var name = arabic ? namesAr[kind] : names[kind];
      var description = arabic ? 'رسم قياسات ' + name + ' في URA Fit' : 'URA Fit ' + name + ' measurement blueprint';
      var url;

      root.setAttribute('data-ura-fit-kind', kind);
      root.setAttribute('aria-label', description);

      if (image) {
        url = image.getAttribute('data-src-' + kind);
        if (url && image.getAttribute('src') !== url) image.setAttribute('src', url);
        image.setAttribute('alt', description);
      }

      if (heading) heading.textContent = (arabic ? 'القطعة مفرودة / ' : 'FLAT / ') + name;
      if (widthLabel) widthLabel.textContent = arabic ? (bottoms[kind] ? 'عرض الخصر' : 'العرض والقطعة مفرودة') : (bottoms[kind] ? 'WAIST WIDTH' : 'FLAT WIDTH');

      activate(root, root.getAttribute('data-active-measure') || 'width', false);
    }

    function showDemoStage(root, stage) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-ura-demo-panel]'), function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-ura-demo-panel') === stage);
      });
      root.setAttribute('data-ura-demo-stage', stage);
    }

    function clearDemo(root) {
      (root.uraDemoTimers || []).forEach(function (timer) {
        window.clearTimeout(timer);
      });
      root.uraDemoTimers = [];
    }

    function after(root, delay, callback) {
      root.uraDemoTimers.push(window.setTimeout(callback, delay));
    }

    function runDemo(root, force) {
      var swatches = root.querySelectorAll('.ura-fit-demo__swatches i');
      var colorName = root.querySelector('[data-ura-demo-color-name]');
      var kind = root.getAttribute('data-ura-fit-kind') || 'tshirt';
      var secondMeasure = bottoms[kind] ? 'hip' : 'length';

      if (!force && root.getAttribute('data-ura-fit-demo-ran') === 'true') return;
      root.setAttribute('data-ura-fit-demo-ran', 'true');
      clearDemo(root);
      root.classList.remove('is-demo-complete');
      showDemoStage(root, reduce ? 'result' : 'color');

      Array.prototype.forEach.call(swatches, function (swatch, index) {
        swatch.classList.toggle('is-active', index === 0);
      });
      if (colorName) colorName.textContent = isArabic(root) ? 'أخضر داكن' : 'DARK GREEN';

      if (reduce) {
        activate(root, 'width', false);
        root.classList.add('is-demo-complete');
        return;
      }

      after(root, 650, function () {
        Array.prototype.forEach.call(swatches, function (swatch, index) {
          swatch.classList.toggle('is-active', index === 1);
        });
        if (colorName) colorName.textContent = isArabic(root) ? 'URA Clay' : 'URA CLAY';
      });
      after(root, 1450, function () { showDemoStage(root, 'answer'); });
      after(root, 3050, function () {
        showDemoStage(root, 'measure');
        activate(root, 'width', true);
      });
      after(root, 4350, function () { activate(root, secondMeasure, true); });
      after(root, 5900, function () { showDemoStage(root, 'result'); });
      after(root, 7800, function () { root.classList.add('is-demo-complete'); });
    }

    function bindDemo(root) {
      var page = root.closest('[data-upf]');
      var mode = root.getAttribute('data-ura-fit-demo-mode');

      if (mode === 'library' && page) page.classList.add('is-ura-demo-library');

      Array.prototype.forEach.call(root.querySelectorAll('[data-ura-demo-kind]'), function (button) {
        button.addEventListener('click', function () {
          Array.prototype.forEach.call(root.querySelectorAll('[data-ura-demo-kind]'), function (item) {
            item.classList.toggle('is-active', item === button);
          });
          setKind(root, button.getAttribute('data-ura-demo-kind'));
          runDemo(root, true);
        });
      });

      var replay = root.querySelector('[data-ura-demo-replay]');
      if (replay) replay.addEventListener('click', function () { runDemo(root, true); });
    }

    function activate(root, measure, replay) {
      var kind = root.getAttribute('data-ura-fit-kind') || 'tshirt';
      var shape = measure === 'flat' ? '' : ((paths[kind] || paths.tshirt)[measure] || (paths[kind] || paths.tshirt).width);
      var trace = root.querySelector('[data-ura-fit-trace]');
      var aura = root.querySelector('[data-ura-fit-aura]');
      var label = root.querySelector('[data-ura-fit-live-label]');

      if (trace) trace.setAttribute('d', shape);
      if (aura) aura.setAttribute('d', shape);
      if (label) label.textContent = measurementLabel(kind, measure, root);
      root.setAttribute('data-active-measure', measure);
      var points = shape.match(/-?\d+(?:\.\d+)?/g);
      var first = root.querySelector('[data-ura-fit-start]');
      var last = root.querySelector('[data-ura-fit-end]');
      [first,last].forEach(function(point,index){
        if(!point)return;
        point.setAttribute('visibility',points&&points.length>=4?'visible':'hidden');
        if(points&&points.length>=4){point.setAttribute('cx',points[index?points.length-2:0]);point.setAttribute('cy',points[index?points.length-1:1]);}
      });
      root.dispatchEvent(new CustomEvent('ura:fit-measure',{bubbles:true,detail:{measure:measure}}));
      root.classList.remove('is-drawing');

      if (replay === false || reduce || measure === 'flat') return;

      void root.offsetWidth;
      root.classList.add('is-drawing');
      window.clearTimeout(root.uraFitTimer);

      if (!reduce) {
        root.uraFitTimer = window.setTimeout(function () {
          root.classList.remove('is-drawing');
        }, 920);
      }
    }

    function init(root) {
      if (root.getAttribute('data-ura-fit-ready') === 'true') {
        setKind(root, kindFor(root));
        return;
      }

      root.setAttribute('data-ura-fit-ready', 'true');
      setKind(root, kindFor(root));

      if (!root.hasAttribute('data-ura-fit-demo')) return;
      bindDemo(root);

      var run = function () {
        runDemo(root, false);
      };

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            run();
          }
        }, { threshold: .35 });
        observer.observe(root);
      } else {
        run();
      }
    }

    function measurementFor(input) {
      if (input.matches('[data-pdp-fit-width], [data-upf-chest], [data-fit-room-width]')) return 'width';
      if (input.matches('[data-pdp-fit-length], [data-upf-length], [data-fit-room-length]')) return 'length';
      if (input.matches('[data-pdp-fit-shoulder], [data-upf-shoulder]')) return 'shoulder';
      if (input.matches('[data-pdp-fit-hip], [data-upf-hip]')) return 'hip';
      return input.getAttribute('data-ura-fit-measure');
    }

    function fromInput(event) {
      var input = event.target && event.target.closest
        ? event.target.closest('[data-pdp-fit-width], [data-pdp-fit-length], [data-upf-chest], [data-upf-length], [data-fit-room-width], [data-fit-room-length], [data-pdp-fit-shoulder], [data-upf-shoulder], [data-pdp-fit-hip], [data-upf-hip], [data-ura-fit-measure]')
        : null;
      var scope;
      var root;
      var measure;

      if (!input) return;
      scope = input.closest('[data-pdp-fit], [data-upf], [data-fit-room]');
      root = scope && scope.querySelector('[data-ura-fit-blueprint]');
      measure = measurementFor(input);
      if (root && measure) activate(root, measure, true);
    }

    function syncAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ura-fit-blueprint]'), init);
    }

    document.addEventListener('input', fromInput, true);
    document.addEventListener('focusin', fromInput, true);
    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches || !event.target.matches('[data-upf-product]')) return;
      window.setTimeout(syncAll, 0);
    }, true);
    document.addEventListener('shopify:section:load', syncAll);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.target.matches('[data-ura-fit-blueprint]')) {
          setKind(mutation.target, kindFor(mutation.target));
        }
      });
    });

    function ready() {
      syncAll();
      Array.prototype.forEach.call(document.querySelectorAll('[data-ura-fit-blueprint]'), function (root) {
        observer.observe(root, { attributes: true, attributeFilter: ['data-garment-type'] });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready, { once: true });
    } else {
      ready();
    }

    window.URAFitBlueprint = {
      activate: activate,
      setKind: setKind,
      classify: classify,
      init: init
    };
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-hero-pre-framed-0925"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const bind = root => {
    if (root.dataset.umh4Bound) return;
    root.dataset.umh4Bound = 'true';

    const video = root.querySelector('.umh4__video');
    const motion = root.querySelector('[data-ura-hero-motion]');
    const header = document.querySelector('[data-ura-header]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const saveData = navigator.connection && navigator.connection.saveData;
    const events = new AbortController();
    const opts = { signal: events.signal };
    let introTimer = 0;
    let revealed = false;
    let userRequestedPlay = false;

    const setLabel = state => {
      if (!motion) return;
      const key = state === 'ended' ? 'replayLabel' : state === 'paused' ? 'playLabel' : 'pauseLabel';
      motion.setAttribute('aria-label', motion.dataset[key] || '');
    };

    const setProgress = () => {
      if (!motion || !Number.isFinite(video.duration) || video.duration <= 0) return;
      motion.style.setProperty('--video-progress', String(Math.min(1, video.currentTime / video.duration)));
    };

    const finishIntro = () => {
      if (revealed) return;
      revealed = true;
      clearTimeout(introTimer);
      clearTimeout(window.uraSeamSafety);
      root.classList.remove('is-intro-playing');
      document.documentElement.classList.remove('ura-seam-pending');
      document.dispatchEvent(new CustomEvent('ura:intro-reveal'));
      if (!reduced.matches && !saveData) startVideo();
    };

    const startVideo = () => {
      const src = root.dataset.videoSrc;
      if (!src) return;
      if (!video.src) {
        video.src = src;
        video.load();
      }
      video.play().then(() => {
        root.classList.remove('is-paused','is-ended');
        root.classList.add('is-playing');
        setLabel('playing');
      }).catch(() => {
        root.classList.add('is-paused');
        setLabel('paused');
      });
    };

    const config = window.uraSeamIntro || {};
    const introActive = document.documentElement.classList.contains('ura-seam-pending') && config.play === true;

    if (introActive) {
      root.classList.add('is-intro-playing');
      introTimer = setTimeout(finishIntro, config.duration || 1180);
    } else {
      finishIntro();
    }

    if (!introActive && !reduced.matches && !saveData) startVideo();

    video.addEventListener('playing', () => {
      root.classList.remove('is-paused','is-ended');
      root.classList.add('is-playing');
      setLabel('playing');
    }, opts);

    video.addEventListener('timeupdate', setProgress, opts);

    video.addEventListener('pause', () => {
      if (!video.ended) {
        root.classList.add('is-paused');
        root.classList.remove('is-playing');
        setLabel('paused');
      }
    }, opts);

    video.addEventListener('ended', () => {
      root.classList.add('is-ended');
      root.classList.remove('is-paused','is-playing');
      motion && motion.style.setProperty('--video-progress','1');
      setLabel('ended');
    }, opts);

    video.addEventListener('error', () => {
      root.classList.add('is-ended');
      setLabel('ended');
    }, opts);

    if (motion) {
      motion.addEventListener('click', () => {
        userRequestedPlay = true;
        if (video.ended || root.classList.contains('is-ended')) {
          video.currentTime = 0;
          motion.style.setProperty('--video-progress','0');
          root.classList.remove('is-ended');
          startVideo();
          return;
        }
        if (video.paused) startVideo();
        else video.pause();
      }, opts);
    }

    const skipIntro = () => {
      if (!revealed) finishIntro();
    };

    window.addEventListener('wheel', skipIntro, { ...opts, passive: true, once: true });
    window.addEventListener('touchmove', skipIntro, { ...opts, passive: true, once: true });
    window.addEventListener('scroll', () => {
      if (window.scrollY > 12) skipIntro();
    }, { ...opts, passive: true });
    window.addEventListener('keydown', event => {
      if (['Escape','PageDown','End',' ','ArrowDown'].includes(event.key)) skipIntro();
    }, opts);

    reduced.addEventListener('change', () => {
      if (reduced.matches) {
        video.pause();
        finishIntro();
      } else if (userRequestedPlay) {
        startVideo();
      }
    }, opts);

    if (header) {
      const measure = () => root.style.setProperty('--umh4-header', Math.ceil(header.getBoundingClientRect().height) + 'px');
      const observer = new ResizeObserver(measure);
      observer.observe(header);
      measure();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) {
          observer.disconnect();
          events.abort();
          clearTimeout(introTimer);
          video.pause();
        }
      }, opts);
    }
  };

  document.querySelectorAll('[data-ura-360-hero]').forEach(bind);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-ura-360-hero]').forEach(bind);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-home-magnetic"] && !Shopify.designMode) return;
  try {
    (()=>{
 const body=document.body;
 if(body.dataset.uraMotion)return;
 body.dataset.uraMotion='unified-0914-polish';
 const fine=matchMedia('(hover:hover) and (pointer:fine)'),reduce=matchMedia('(prefers-reduced-motion:reduce)'),home=body.classList.contains('template-index');
 const events=new AbortController(),signal=events.signal,clamp=(n,a,b)=>Math.min(b,Math.max(a,n));
 const globalRules=[['.ura-header__tile','header'],['.ura-header__brand','quiet'],['.ura-language__trigger','icon'],['.ura-language__option','quiet'],['.ura-header .ura-bag','icon'],['.ura-header shopify-account','account'],['.ura-shop-card','row'],['.ura-shop-card__disclosure,[data-ura-menu-close]','row'],['.ura-shop-menu__browse a','row'],['.ura-shop-card__edits a,.ura-shop-menu__bottom>nav>a','quiet'],['.ura-shop-menu__studio','row'],['.ucv__controls button,.ura4-gallery__arrows button,.ura4-lightbox__nav button,.ura-arrivals__controls button,.ura2-filter-room__panel>header>button,.ura-cart-drawer__head [data-ura-cart-drawer-close]','icon'],['.ura4-buy__add,.ura-cart-drawer__checkout,.ura2-filter-room__panel>footer button:last-child,.ura-cart-drawer__explore','pill'],['.ura4-focus-actions button,.ura2-refine-trigger,.ura-cart-drawer__links>a,.ura-cart-drawer__links>button,.ura-cart-drawer__other-payments,.ura2-active-filters>div button,.ura2-catalog__empty button,.ura2-filter-room__panel>footer button:first-child,.ura4-lightbox__bar>button','pill']];
 const homeRules=[['.ura-campaign-hero__cta','pill'],['.ura-campaign-hero__scroll,.ura-campaign-hero__shipping','quiet'],['.ura-opening__cta,.uac-head__aside>a,.uac-piece-link,.ufx-link,.ums__actions>a,.uhr-fit .uhr-button,.ufe-product-link,.uhc__all,.uv42-home__copy>a,.uac-full','pill'],['.ura-opening__scroll,.ura-opening__shipping,.ura-opening-detail__end>a,.uac-quick-link,.uac-skip,.ums__detail-content a','quiet'],['[data-uac-photo-button],.ums__tabs>a,.ums__detail summary,.ufe-garment-choices button,.ufe-cinema-garments>summary,[data-collection-tab]','row'],['[data-uac-prev],[data-uac-next],[data-material-prev],[data-material-next],.uac-dialog__close','icon'],['[data-ufe-play]','dynamic'],['.uf27-trust>a','quiet'],['.uhc__collection','collection'],['.uac-add','row']];
 const rules=home?[...globalRules,...homeRules]:globalRules;
 const properties=['--ura-mag-x','--ura-mag-y','--ura-mag-scale','--ura-mag-scale-y','--ura-mag-origin'];
 let active=null,last=null,frame=0,scanFrame=0,scrollFrame=0;
 const reset=()=>{if(active){active.removeAttribute('data-ura-magnetic-active');properties.forEach(key=>active.style.removeProperty(key));active=null;}};
 const stop=()=>{cancelAnimationFrame(frame);frame=0;last=null;reset();};
 const logos=new Set();
 const logoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;const el=entry.target;if(!reduce.matches)el.setAttribute('data-ura-logo-enter','');logoObserver.unobserve(el);}),{threshold:.3});
 const prepareLogo=el=>{
  if(!home||logos.has(el))return;
  const img=el.querySelector('[data-ura-official-wordmark]');
  if(!img)return;
  const canvas=document.createElement('span');canvas.className='ura-logo-canvas';
  img.before(canvas);canvas.append(img);
  [[0,70],[30,35],[65,0]].forEach(([left,right],i)=>{
   const part=document.createElement('span');part.className='ura-logo-segment';part.setAttribute('aria-hidden','true');part.style.setProperty('--ura-letter',String(i));part.style.setProperty('--ura-clip-left',left+'%');part.style.setProperty('--ura-clip-right',right+'%');
   const copy=img.cloneNode();copy.removeAttribute('data-ura-official-wordmark');copy.removeAttribute('id');copy.alt='';copy.loading=img.loading;part.append(copy);canvas.append(part);
  });
  el.setAttribute('data-ura-logo','');logos.add(el);logoObserver.observe(el);
 };
 const prepare=el=>{
  if(el.hasAttribute('data-ura-magnetic-ready'))return;
  const kind=el.dataset.uraMagnetic||'quiet';el.dataset.uraMagnetic=kind;el.setAttribute('data-ura-magnetic-ready','');
  if(kind==='logo'){prepareLogo(el);return;}
  if(kind==='collection'||kind==='account'||kind==='dynamic')return;
  Array.from(el.childNodes).forEach(node=>{if(node.nodeType===Node.TEXT_NODE&&node.textContent.trim()){const span=document.createElement('span');span.setAttribute('data-ura-magnetic-copy','');node.before(span);span.append(node);}});
  if(kind==='pill'||kind==='icon'){const surface=document.createElement('span');surface.className='ura-magnet-surface';surface.setAttribute('aria-hidden','true');el.append(surface);}
 };
 const scan=()=>{
  scanFrame=0;
  rules.forEach(([selector,kind])=>document.querySelectorAll(selector).forEach(el=>{if(!el.hasAttribute('data-ura-magnetic-ready'))el.dataset.uraMagnetic=kind;}));
  document.querySelectorAll('[data-ura-magnetic]').forEach(prepare);
 };
 const target=event=>{
  if(!(event.target instanceof Element))return null;
  const el=event.target.closest('[data-ura-magnetic]');
  if(!el||el.closest('[inert],[hidden],[aria-hidden=true]')||el.matches(':disabled,[aria-disabled=true]')||!el.getClientRects().length)return null;
  return el;
 };
 const paint=()=>{
  frame=0;if(!last||!fine.matches||reduce.matches||document.hidden){reset();return;}
  const {el,x,y}=last;
  if(!el.isConnected||el.matches(':disabled,[aria-disabled=true]')||el.closest('[inert],[hidden],[aria-hidden=true]')){stop();return;}
  if(active!==el){reset();active=el;}
  const r=el.getBoundingClientRect();if(!r.width||!r.height)return;
  const nx=clamp((x-r.left-r.width/2)/(r.width/2),-1,1),ny=clamp((y-r.top-r.height/2)/(r.height/2),-1,1),kind=el.dataset.uraMagnetic;
  const pull=Math.min(kind==='header'?3.8:kind==='logo'?4.2:kind==='pill'?3.2:kind==='icon'||kind==='dynamic'?2.6:2.4,r.width*.06);
  const stretch=Math.min(kind==='header'?.07:kind==='pill'?.035:kind==='icon'||kind==='dynamic'?.04:kind==='row'?.015:.012,5/r.width);
  el.setAttribute('data-ura-magnetic-active','');el.style.setProperty('--ura-mag-x',(nx*pull).toFixed(2)+'px');el.style.setProperty('--ura-mag-y',(ny*(kind==='logo'?2.7:2.35)).toFixed(2)+'px');el.style.setProperty('--ura-mag-scale',(1+Math.abs(nx)*stretch).toFixed(3));el.style.setProperty('--ura-mag-scale-y',(1+Math.abs(ny)*.014).toFixed(3));el.style.setProperty('--ura-mag-origin',(50-nx*28).toFixed(2)+'%');
 };
 document.addEventListener('pointermove',event=>{if(event.pointerType!=='mouse'||!fine.matches||reduce.matches){stop();return;}const el=target(event);if(!el){stop();return;}prepare(el);last={el,x:event.clientX,y:event.clientY};if(!frame)frame=requestAnimationFrame(paint);},{passive:true,signal});
 document.addEventListener('pointerout',event=>{if(active&&!active.contains(event.relatedTarget))stop();},{passive:true,signal});
 ['pointercancel','focusin','keydown'].forEach(name=>document.addEventListener(name,stop,{signal}));
 document.addEventListener('pointerdown',stop,{passive:true,signal});
 document.addEventListener('click',stop,{passive:true,signal});
 window.addEventListener('blur',stop,{signal});
 document.addEventListener('visibilitychange',stop,{signal});
 fine.addEventListener('change',stop,{signal});reduce.addEventListener('change',stop,{signal});
 let readingLine=null;
 const trackReading=()=>{scrollFrame=0;if(!readingLine||reduce.matches||document.hidden||!readingLine.getClientRects().length)return;const travel=document.documentElement.scrollHeight-innerHeight;const value=(travel>0?clamp(scrollY/travel,0,1):0).toFixed(4);if(readingLine.style.getPropertyValue('--ura-page-progress')!==value)readingLine.style.setProperty('--ura-page-progress',value);};
 if(home){const header=document.querySelector('[data-ura-header]');if(header){const line=document.createElement('span');line.className='ura-reading-line';line.setAttribute('aria-hidden','true');header.append(line);readingLine=line;}window.addEventListener('scroll',()=>{stop();if(!scrollFrame)scrollFrame=requestAnimationFrame(trackReading);},{passive:true,signal});window.addEventListener('resize',trackReading,{passive:true,signal});trackReading();}
 const observer=new MutationObserver(records=>{if(active&&active.closest('[inert],[hidden],[aria-hidden=true]'))stop();if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1))&&!scanFrame)scanFrame=requestAnimationFrame(scan);});
 scan();observer.observe(body,{subtree:true,childList:true});
 document.addEventListener('shopify:section:load',scan,{signal});
 document.addEventListener('shopify:section:unload',event=>{if(active&&event.target.contains(active))stop();logos.forEach(el=>{if(event.target.contains(el)){logoObserver.unobserve(el);logos.delete(el);}});},{signal});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-home-premium"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mounts=new Map();
 const mount=scope=>scope.querySelectorAll('[data-ura-home-premium]').forEach(root=>{
  if(mounts.has(root))return;
  const anchors=[...root.querySelectorAll('.ura-piece-story__layout,.ucw__card')];
  const reduced=matchMedia('(prefers-reduced-motion:reduce)'),events=new AbortController();
  let frame=0;
  const set=(node,key,value)=>{if(node.style.getPropertyValue(key)!==value)node.style.setProperty(key,value);};
  const clear=()=>{
   root.removeAttribute('data-ura-home-motion');
   anchors.forEach(anchor=>['image','copy','opacity','line'].forEach(key=>anchor.style.removeProperty('--ura-enter-'+key)));
  };
  const paint=()=>{
   frame=0;if(document.hidden||!root.isConnected)return;if(reduced.matches){clear();return;}
   const height=window.innerHeight;
   const positions=anchors.map(anchor=>anchor.getBoundingClientRect().top);
   if(!root.hasAttribute('data-ura-home-motion'))root.setAttribute('data-ura-home-motion','');
   anchors.forEach((anchor,index)=>{
    const y=positions[index];
    const p=Math.max(0,Math.min(1,(height*.92-y)/(height*.42)));
    const eased=p*p*(3-2*p);
    set(anchor,'--ura-enter-image',((1-eased)*18).toFixed(2)+'px');
    set(anchor,'--ura-enter-copy',((1-eased)*10).toFixed(2)+'px');
    set(anchor,'--ura-enter-opacity',(.86+eased*.14).toFixed(4));
    set(anchor,'--ura-enter-line',eased.toFixed(4));
   });
  };
  const queue=()=>{if(!document.hidden&&!frame)frame=requestAnimationFrame(paint);};
  document.addEventListener('visibilitychange',queue,{signal:events.signal});
  window.addEventListener('scroll',queue,{passive:true,signal:events.signal});
  window.addEventListener('resize',queue,{passive:true,signal:events.signal});
  reduced.addEventListener('change',queue,{signal:events.signal});
  mounts.set(root,()=>{events.abort();cancelAnimationFrame(frame);clear();});
  queue();
 });
 const boot=()=>mount(document);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('shopify:section:unload',event=>mounts.forEach((dispose,root)=>{if(event.target.contains(root)){dispose();mounts.delete(root);}}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-language-switcher"] && !Shopify.designMode) return;
  try {
    (()=>{
 const mounted=new Map();
 const mount=scope=>scope.querySelectorAll('form.ura-language__form').forEach(form=>{
  if(mounted.has(form))return;
  const root=form.closest('.ura-language'),select=form.querySelector('select[name="language_code"]'),trigger=form.querySelector('.ura-language__trigger'),panel=form.querySelector('.ura-language__panel'),options=[...form.querySelectorAll('[data-language]')];
  if(!select||!trigger||!panel)return;
  const events=new AbortController(),signal=events.signal;
  const retainPage=()=>{let input=form.querySelector('input[name="return_to"]');if(!input){input=document.createElement('input');input.type='hidden';input.name='return_to';form.append(input);}input.value=location.pathname+location.search+location.hash;};
  const setOpen=(open,focus=false)=>{panel.hidden=!open;trigger.setAttribute('aria-expanded',String(open));if(open&&focus)(options.find(o=>o.hasAttribute('aria-current'))||options[0])?.focus();};
  const submit=()=>{retainPage();if(form.requestSubmit)form.requestSubmit();else form.submit();};
  trigger.addEventListener('click',()=>setOpen(panel.hidden),{signal});
  trigger.addEventListener('keydown',e=>{if(['ArrowDown','ArrowUp'].includes(e.key)){e.preventDefault();setOpen(true,true);}},{signal});
  options.forEach(o=>o.addEventListener('click',()=>{if(o.dataset.language===select.value){setOpen(false);trigger.focus();return;}select.value=o.dataset.language;submit();},{signal}));
  form.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){e.preventDefault();setOpen(false);trigger.focus();}const n=options.indexOf(e.target);if(n>=0&&['ArrowDown','ArrowUp','Home','End'].includes(e.key)){e.preventDefault();options[e.key==='Home'?0:e.key==='End'?options.length-1:(n+(e.key==='ArrowDown'?1:-1)+options.length)%options.length].focus();}},{signal});
  document.addEventListener('pointerdown',e=>{if(!root.contains(e.target))setOpen(false);},{signal});
  form.addEventListener('focusout',e=>{if(!form.contains(e.relatedTarget))setOpen(false);},{signal});
  select.addEventListener('change',submit,{signal});form.addEventListener('submit',retainPage,{signal});root.dataset.enhanced='true';trigger.hidden=false;
  mounted.set(form,()=>{events.abort();mounted.delete(form);});
 });
 const all=()=>mount(document);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();
 document.addEventListener('shopify:section:load',e=>mount(e.target));document.addEventListener('shopify:section:unload',e=>mounted.forEach((destroy,form)=>{if(e.target.contains(form))destroy();}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-material-journey"] && !Shopify.designMode) return;
  try {
    (()=>{
 const registry=new Map();
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const mount=scope=>scope.querySelectorAll('[data-material-stage]').forEach(root=>{
  if(registry.has(root))return;
  const rail=root.querySelector('[data-material-rail]');
  const panels=[...root.querySelectorAll('[data-material-panel]')];
  const tabs=[...root.querySelectorAll('[data-material-tab]')];
  const prev=root.querySelector('[data-material-prev]'),next=root.querySelector('[data-material-next]');
  const count=root.querySelector('[data-material-count]'),controls=root.querySelector('[data-material-controls]');
  const track=root.closest('[data-material-track]');
  const details=track?.nextElementSibling?.matches('[data-material-details]')?track.nextElementSibling:null;
  if(!rail||panels.length<2)return;
  const events=new AbortController();
  const clamp=index=>Math.max(0,Math.min(panels.length-1,index));
  let active=-1,frame=0,width=0,top=80,step=500,storyEnabled=!!track,pending=-1,pendingDeadline=0;
  const direction=()=>getComputedStyle(root).direction==='rtl'?-1:1;
  const unit=value=>Math.max(0,Math.min(1,value));
  const ease=value=>{const t=unit(value);return t*t*(3-2*t);};
  const renderStory=progress=>{
   if(!storyEnabled)return;
   panels.forEach((panel,index)=>{
    const local=progress-index;
    const reveal=index===0?1:ease((local+.3)/.5);
    const covered=index<panels.length-1&&progress>=index+1.2;
    panel.toggleAttribute('data-material-visible',reveal>.001&&!covered);
    panel.style.setProperty('--ums-layer',String(index+1));
    panel.style.setProperty('--ums-wipe-top',((1-reveal)*100).toFixed(3)+'%');
    panel.style.setProperty('--ums-photo-scale',(1.02+.02*ease(local)).toFixed(4));
    panel.style.setProperty('--ums-photo-y',((1-reveal)*5).toFixed(3)+'%');
    panel.style.setProperty('--ums-copy-y',((1-reveal)*36).toFixed(2)+'px');
    tabs[index]?.style.setProperty('--ums-tab-progress',unit(local).toFixed(4));
   });
  };
  root.dataset.ready='true';
  if(track)root.dataset.scrollStory='true';
  if(controls)controls.hidden=false;
  const paint=index=>{
   const target=clamp(index);if(target===active)return;active=target;
   root.dataset.materialActive=panels[active].dataset.materialKey||'';
   panels[active].querySelectorAll('img').forEach(img=>img.loading='eager');
   tabs.forEach((tab,i)=>{if(i===active)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});
   panels.forEach((panel,i)=>{
    if(i!==active&&panel.contains(document.activeElement))tabs[active]?.focus({preventScroll:true});
    panel.inert=i!==active;panel.setAttribute('aria-hidden',String(i!==active));panel.toggleAttribute('data-active',i===active);
   });
   if(prev)prev.disabled=active===0;if(next)next.disabled=active===panels.length-1;
   if(count)count.textContent=String(active+1).padStart(2,'0')+' / '+String(panels.length).padStart(2,'0');
  };
  const update=()=>{
   frame=0;if(!track||!storyEnabled)return;
   const distance=top-track.getBoundingClientRect().top;
   root.style.setProperty('--ums-progress',String(Math.max(0,Math.min(1,distance/(step*panels.length)))));
   if(pending>=0){if(Math.abs(distance/step-pending-.25)<.04||performance.now()>pendingDeadline)pending=-1;else{renderStory(pending+.25);queue();return;}}
   const progress=Math.max(0,Math.min(panels.length,distance/step));
   paint(clamp(Math.floor(progress)));
   renderStory(progress);
  };
  const queue=()=>{if(!frame)frame=requestAnimationFrame(update);};
  const select=(index,instant=false)=>{
   const target=clamp(index);
   if(track&&!storyEnabled){
    panels[target].scrollIntoView({block:'start',behavior:'instant'});
   }else if(track){
    const start=scrollY+track.getBoundingClientRect().top-top;
    pending=-1;
    window.scrollTo({top:Math.max(0,start+(target+.255)*step+2),behavior:instant||reduced.matches?'instant':'smooth'});
    queue();
   }else{
    panels[target].querySelectorAll('img').forEach(img=>img.loading='eager');
    rail.scrollTo({left:target*rail.clientWidth,behavior:instant||reduced.matches?'instant':'smooth'});
    if(instant)paint(target);
   }
  };
  tabs.forEach((tab,index)=>{
   tab.addEventListener('click',event=>{
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();select(index);
    if(root.dataset.materialContext==='page')history.replaceState(history.state,'','#ufi2-'+panels[index].dataset.materialKey);
   },{signal:events.signal});
   tab.addEventListener('keydown',event=>{
    let target;
    if(event.key==='ArrowRight')target=clamp(index+direction());
    else if(event.key==='ArrowLeft')target=clamp(index-direction());
    else if(event.key==='Home')target=0;
    else if(event.key==='End')target=panels.length-1;
    else return;
    event.preventDefault();tabs[target].focus({preventScroll:true});select(target);
   },{signal:events.signal});
  });
  prev?.addEventListener('click',()=>select(active-1),{signal:events.signal});
  next?.addEventListener('click',()=>select(active+1),{signal:events.signal});
  rail.addEventListener('keydown',event=>{
   if(event.target!==rail||!['ArrowRight','ArrowLeft'].includes(event.key))return;
   event.preventDefault();select(active+(event.key==='ArrowRight'?1:-1)*direction());
  },{signal:events.signal});
  const hash=()=>{
   const index=panels.findIndex(panel=>'#'+panel.id===location.hash||'#ufi2-'+panel.dataset.materialKey===location.hash);
   if(index<0)return;select(index,true);
   if(!track)root.scrollIntoView({block:'start',behavior:'instant'});
  };
  root.style.scrollMarginTop='88px';
  const measure=()=>{
   pending=-1;
   if(track){
    top=Math.ceil(document.querySelector('[data-ura-header]')?.getBoundingClientRect().height||68);
    const previewInset=document.getElementById('PBarNextFrame')?76:0;
    const available=Math.min(innerHeight,window.visualViewport?.height||innerHeight)-top-previewInset-12;
    root.style.setProperty('--ums-story-top',top+'px');
    root.style.setProperty('--ums-preview-inset',previewInset+'px');
    root.style.setProperty('--ums-stage-height',Math.max(0,Math.floor(available))+'px');
    root.toggleAttribute('data-compact',available<520);
    storyEnabled=!reduced.matches&&available>=330;
    root.toggleAttribute('data-scroll-story',storyEnabled);
    if(storyEnabled){
     const tallest=Math.max(...panels.map(panel=>panel.querySelector('.ums__record')?.scrollHeight||0));
     const allowance=innerWidth<=760?140:150;
     if(tallest+allowance>available){storyEnabled=false;root.removeAttribute('data-scroll-story');}
    }
    root.toggleAttribute('data-material-static',!storyEnabled);
    if(details)details.hidden=!storyEnabled;
    tabs.forEach(tab=>{if(!storyEnabled)tab.removeAttribute('aria-current');});
    if(!storyEnabled){
     track.style.height='';controls.hidden=true;
     panels.forEach(panel=>{panel.inert=false;panel.removeAttribute('aria-hidden');panel.setAttribute('data-active','');panel.removeAttribute('data-material-visible');});
     tabs.forEach(tab=>tab.style.removeProperty('--ums-tab-progress'));
     active=-1;return;
    }
    controls.hidden=false;
    root.style.setProperty('--ums-story-top',top+'px');
    root.style.setProperty('--ums-preview-inset',document.getElementById('PBarNextFrame')?'76px':'0px');
    const height=root.getBoundingClientRect().height;
    step=Math.max(560,Math.round(height*1.65));
    const value=Math.round(height+step*panels.length)+'px';
    if(track.style.height!==value)track.style.height=value;
    queue();
   }else if(Math.abs(rail.clientWidth-width)>1){width=rail.clientWidth;select(Math.max(0,active),true);}
  };
  const observer=new ResizeObserver(measure);observer.observe(root);
  panels.forEach(panel=>{const record=panel.querySelector('.ums__record');if(record)observer.observe(record);});
  const preload=new IntersectionObserver(entries=>{
   if(entries.some(entry=>entry.isIntersecting)){panels.forEach(panel=>panel.querySelectorAll('img').forEach(img=>img.loading='eager'));preload.disconnect();}
  },{rootMargin:'800px 0px'});preload.observe(root);
  if(track){
   ['wheel','touchstart','pointerdown','keydown'].forEach(name=>window.addEventListener(name,()=>{pending=-1;},{passive:true,capture:true,signal:events.signal}));
   window.addEventListener('scroll',queue,{passive:true,signal:events.signal});
   let storyWidth=innerWidth;window.addEventListener('resize',()=>{if(Math.abs(innerWidth-storyWidth)>2||matchMedia('(pointer:fine)').matches){storyWidth=innerWidth;measure();}else queue();},{passive:true,signal:events.signal});
   window.addEventListener('pageshow',measure,{signal:events.signal});
  }else{
   rail.addEventListener('scroll',()=>{
    if(frame)return;frame=requestAnimationFrame(()=>{frame=0;paint(Math.round(rail.scrollLeft/Math.max(1,rail.clientWidth)));});
   },{passive:true,signal:events.signal});
  }
  window.addEventListener('hashchange',hash,{signal:events.signal});
  reduced.addEventListener('change',measure,{signal:events.signal});
  paint(0);measure();hash();
  registry.set(root,()=>{events.abort();observer.disconnect();preload.disconnect();cancelAnimationFrame(frame);if(track)track.style.height='';if(details)details.hidden=true;});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [root,cleanup] of registry)if(event.target.contains(root)){cleanup();registry.delete(root);}});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-material-lens"] && !Shopify.designMode) return;
  try {
    (()=>{document.addEventListener('toggle',event=>{const root=event.target;if(!root.matches?.('[data-material-lens]')||!root.open)return;const template=root.querySelector('[data-lens-image]');const host=root.querySelector('[data-lens-photo]');if(template&&host){host.append(template.content.cloneNode(true));template.remove();}},true);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-material-library-page"] && !Shopify.designMode) return;
  try {
    (()=>{
  const registry=new Map();
  const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));
  const ease=n=>n*n*(3-2*n);

  const mount=scope=>scope.querySelectorAll('[data-fabric-library-page]').forEach(root=>{
    if(registry.has(root))return;

    const shell=root.querySelector('.ufl__shell');
    const journey=root.querySelector('[data-library-journey]');
    const story=root.querySelector('[data-library-story-shell]');
    const stage=root.querySelector('[data-library-stage]');
    const panels=[...root.querySelectorAll('[data-library-panel]')];
    const choices=[...root.querySelectorAll('[data-library-choice]')];
    const probe=root.querySelector('[data-library-viewport]');
    if(!shell||!journey||!story||!stage||!probe||panels.length!==4||choices.length!==4)return;

    const events=new AbortController();
    const signal=events.signal;
    const reduced=matchMedia('(prefers-reduced-motion:reduce)');
    let frame=0,active=-1,step=1,pinTop=0,enabled=false,lastWidth=0,lastHeight=0;

    const draw=position=>{
      const p=clamp(position,0,3.45);
      const base=Math.min(3,Math.floor(p));
      const mix=base===3?0:ease(clamp((p-base-.58)/.42,0,1));
      const current=base+(mix>=.5?1:0);

      panels.forEach((panel,i)=>{
        const weight=i===base?1-mix:i===base+1?mix:0;
        panel.style.setProperty('--ufl-opacity',String(weight));
        const phase=clamp(p-i,0,1);
        panel.style.setProperty('--ufl-glint',(-140+phase*280).toFixed(2)+'%');
        panel.style.setProperty('--ufl-pulse',String(Math.sin(phase*Math.PI)*.72));
        panel.style.setProperty('--ufl-ring',String(.85+phase*.15));
        panel.style.setProperty('--ufl-shift',((i===base?-1:1)*(1-weight)*20).toFixed(2)+'px');
        panel.toggleAttribute('data-rendered',weight>0);
        panel.toggleAttribute('data-active',i===current);
        panel.inert=i!==current;
        panel.setAttribute('aria-hidden',String(i!==current));
      });

      choices.forEach((choice,i)=>{
        choice.setAttribute('aria-pressed',String(i===current));
        choice.style.setProperty('--ufl-progress',String(clamp(p-i,0,1)));
      });

      if(current!==active){
        active=current;
        root.dataset.current=panels[current].dataset.libraryPanel;
      }
    };

    const update=()=>{
      frame=0;
      if(!enabled)return;
      const y=root.getBoundingClientRect().top;
      const pad=parseFloat(getComputedStyle(root).paddingTop)||0;
      draw((pinTop-y-pad)/step);
    };

    const queue=()=>{if(!frame)frame=requestAnimationFrame(update)};

    const reset=()=>{
      enabled=false;
      root.removeAttribute('data-story');
      journey.style.removeProperty('height');
      root.style.removeProperty('--ufl-photo-height');
      panels.forEach(panel=>{
        panel.inert=false;
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('data-active');
        panel.removeAttribute('data-rendered');
        panel.style.removeProperty('--ufl-opacity');
        panel.style.removeProperty('--ufl-shift');
      });
      choices.forEach(choice=>choice.setAttribute('aria-pressed','false'));
      active=-1;
    };

    const measure=()=>{
      const header=document.querySelector('[data-ura-header]');
      const headerHeight=Math.ceil(header?.getBoundingClientRect().height||64);
      const viewport=Math.min(probe.getBoundingClientRect().height||innerHeight,innerHeight);
      const preview=document.getElementById('PBarNextFrame')?76:0;

      pinTop=headerHeight+12;
      root.style.setProperty('--ufl-header',headerHeight+'px');
      root.style.setProperty('--ufl-pin-top',pinTop+'px');

      const desktop=innerWidth>920;
      const available=viewport-pinTop-preview-14;
      if(reduced.matches||!desktop||available<580){
        reset();
        return;
      }

      root.setAttribute('data-story','');
      root.style.setProperty('--ufl-photo-height','380px');

      const overhead=story.getBoundingClientRect().height-stage.getBoundingClientRect().height;
      const copyHeight=Math.max(...panels.map(p=>p.querySelector('.ufl__copy')?.getBoundingClientRect().height||0));
      const columns=getComputedStyle(panels[0]).gridTemplateColumns.split(' ');
      const visualWidth=parseFloat(columns[0])||stage.clientWidth*.62;
      const photo=Math.min(620,visualWidth/1.5,available-overhead-2);

      if(photo<340||copyHeight>available-overhead+8){
        reset();
        return;
      }

      root.style.setProperty('--ufl-photo-height',Math.floor(photo)+'px');
      const scene=story.getBoundingClientRect().height;
      if(scene>available+4){
        reset();
        return;
      }

      step=Math.max(420,Math.min(760,viewport*.82));
      journey.style.height=Math.ceil(scene+step*3.45)+'px';
      enabled=true;
      update();
    };

    const jump=index=>{
      if(!enabled){
        panels[clamp(index,0,3)]?.scrollIntoView({behavior:'smooth',block:'start'});
        return;
      }
      const pad=parseFloat(getComputedStyle(root).paddingTop)||0;
      const start=root.getBoundingClientRect().top+scrollY+pad-pinTop;
      window.scrollTo({top:start+clamp(index,0,3)*step,behavior:'smooth'});
    };

    choices.forEach((choice,index)=>{
      choice.addEventListener('click',()=>jump(index),{signal});
      choice.addEventListener('keydown',event=>{
        const rtl=getComputedStyle(root).direction==='rtl';
        let next;
        if(event.key==='ArrowRight')next=index+(rtl?-1:1);
        else if(event.key==='ArrowLeft')next=index+(rtl?1:-1);
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=3;
        else return;
        event.preventDefault();
        next=(next+4)%4;
        choices[next].focus({preventScroll:true});
        jump(next);
      },{signal});
    });

    window.addEventListener('scroll',queue,{signal,passive:true});
    window.addEventListener('resize',()=>{
      const height=probe.getBoundingClientRect().height||innerHeight;
      if(lastWidth!==innerWidth||Math.abs(lastHeight-height)>80){
        lastWidth=innerWidth;
        lastHeight=height;
        measure();
      }
    },{signal,passive:true});
    window.addEventListener('pageshow',measure,{signal});
    reduced.addEventListener('change',measure,{signal});

    const preload=new IntersectionObserver(entries=>{
      if(entries.some(e=>e.isIntersecting)){
        panels.forEach(panel=>panel.querySelectorAll('img').forEach(img=>img.loading='eager'));
      }
    },{rootMargin:'420px'});
    preload.observe(root);

    root.dataset.ready='true';
    root.querySelector('[data-library-index]').hidden=false;

    lastWidth=innerWidth;
    lastHeight=probe.getBoundingClientRect().height||innerHeight;
    measure();
    document.fonts?.ready.then(()=>{if(!signal.aborted)measure()});

    const header=document.querySelector('[data-ura-header]');
    const resizer=typeof ResizeObserver!=='undefined'?new ResizeObserver(measure):null;
    if(header)resizer?.observe(header);

    registry.set(root,()=>{
      events.abort();
      preload.disconnect();
      resizer?.disconnect();
      cancelAnimationFrame(frame);
    });
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});
  }else{
    mount(document);
  }

  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for(const [root,cleanup] of registry){
      if(event.target.contains(root)){
        cleanup();
        registry.delete(root);
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-material-photo"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (scope) => scope.querySelectorAll('[data-ufp]').forEach((viewer) => {
    if (viewer.dataset.ready) return;
    viewer.dataset.ready = 'true';
    const controls = viewer.querySelector('.ufp__controls');
    if (!controls) return;
    controls.hidden = false;
    controls.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ufp-view]');
      if (!button) return;
      viewer.dataset.view = button.dataset.ufpView;
      controls.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    });
  });
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-predictive-search-sep15"] && !Shopify.designMode) return;
  try {
    (()=>{
  const init=root=>{
    if(!root||root.dataset.uraPredictiveReady==='true')return;
    const input=root.querySelector('[data-ura-predictive-input]');
    const form=root.querySelector('[data-ura-predictive-form]');
    const toggle=root.querySelector('[data-ups-toggle]');
    const collapse=root.querySelector('[data-ups-collapse]');
    const results=root.querySelector('[data-ura-predictive-results]');
    const status=root.querySelector('[data-ups-status]');
    if(!input||!form||!toggle||!collapse||!results)return;
    root.dataset.uraPredictiveReady='true';
    let timer=0,controller=null,lastQuery='',requestId=0,expanded=false;
    const announce=text=>{if(status)status.textContent=text;};
    const closeResults=()=>{
      clearTimeout(timer);requestId++;controller?.abort();controller=null;
      results.hidden=true;results.replaceChildren();input.setAttribute('aria-expanded','false');
      root.classList.remove('is-open');root.removeAttribute('aria-busy');announce('');
    };
    const setExpanded=(open,restore=false)=>{
      expanded=open;root.dataset.upsExpanded=String(open);
      toggle.setAttribute('aria-expanded',String(open));toggle.hidden=open;
      form.inert=!open;form.setAttribute('aria-hidden',String(!open));collapse.hidden=!open;
      if(open)input.focus({preventScroll:true});
      else{closeResults();if(restore)toggle.focus({preventScroll:true});}
    };
    const request=async query=>{
      const value=query.trim();
      if(!expanded||value.length<2){lastQuery='';closeResults();return;}
      if(value===lastQuery&&!results.hidden)return;
      lastQuery=value;controller?.abort();controller=new AbortController();
      const current=++requestId;
      root.setAttribute('aria-busy','true');announce(root.dataset.upsLoading);
      const rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      const url=rootPath+'search/suggest?q='+encodeURIComponent(value)+'&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=predictive-search';
      try{
        const response=await fetch(url,{signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
        if(!response.ok)throw new Error('Predictive search request failed');
        const text=await response.text();
        if(current!==requestId||!expanded)return;
        const doc=new DOMParser().parseFromString(text,'text/html');
        const html=doc.querySelector('#shopify-section-predictive-search')?.innerHTML?.trim();
        if(!html){closeResults();return;}
        results.innerHTML=html;results.hidden=false;input.setAttribute('aria-expanded','true');
        root.classList.add('is-open');root.removeAttribute('aria-busy');announce(root.dataset.upsReady);
      }catch(error){if(error.name!=='AbortError'&&current===requestId)closeResults();}
    };
    setExpanded(false);
    toggle.addEventListener('click',()=>setExpanded(true));
    collapse.addEventListener('click',()=>setExpanded(false,true));
    form.addEventListener('submit',event=>{
      if(!input.value.trim()){event.preventDefault();input.focus();return;}
      closeResults();
    });
    input.addEventListener('input',()=>{closeResults();timer=setTimeout(()=>request(input.value),140);});
    input.addEventListener('focus',()=>{if(expanded&&input.value.trim().length>=2)request(input.value);});
    input.addEventListener('keydown',event=>{
      if(event.key==='ArrowDown'&&!results.hidden){const first=results.querySelector('a[href]');if(first){event.preventDefault();first.focus();}}
    });
    root.addEventListener('keydown',event=>{
      if(event.key==='Escape'&&expanded){event.preventDefault();event.stopPropagation();setExpanded(false,true);}
    });
    document.addEventListener('pointerdown',event=>{if(!root.contains(event.target))closeResults();});
    const menu=root.closest('[data-ura-menu]');
    if(menu)new MutationObserver(()=>{
      if(expanded&&(menu.hidden||menu.inert))setExpanded(false);
    }).observe(menu,{attributes:true,attributeFilter:['hidden','inert']});
  };
  document.querySelectorAll('[data-ura-predictive-search]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll?.('[data-ura-predictive-search]').forEach(init));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-qatar-currency-home-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-ura-qatar-home-cards]');
  if (!marker || marker.dataset.uraReady === 'true') return;
  marker.dataset.uraReady = 'true';

  const currencyRoot = document.querySelector('[data-ura-qatar-currency]');
  const configNode = currencyRoot && currencyRoot.querySelector('[data-ura-qar-config]');
  let config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent : '{}');
  } catch (error) {
    config = {};
  }

  const rate = Number(config.rate || (currencyRoot && currencyRoot.dataset.rate) || 3.64);
  const locale = config.locale || document.documentElement.lang || 'en';
  const countrySelectSelector = '[data-ura-qar-country-select]';
  let scheduled = 0;
  let rendering = false;
  let observer;
  let pendingCountry = null;
  let pendingSelect = null;
  let pendingSelectionFrame = 0;
  let selectionObserver;

  function normalizeCountry(value) {
    return value === 'QA' ? 'QA' : 'US';
  }

  function getEventSelect(event) {
    const target = event.target;
    return target && target.matches && target.matches(countrySelectSelector) ? target : null;
  }

  function preservePendingSelection() {
    pendingSelectionFrame = 0;
    if (!pendingCountry) return;
    const select = pendingSelect && document.contains(pendingSelect) ? pendingSelect : document.querySelector(countrySelectSelector);
    if (!select) return;
    select.dataset.uraQarPending = 'true';
    if (select.value !== pendingCountry) select.value = pendingCountry;
  }

  function schedulePendingSelection() {
    if (!pendingCountry || pendingSelectionFrame) return;
    pendingSelectionFrame = window.requestAnimationFrame(preservePendingSelection);
  }

  function rememberPendingSelection(event) {
    const select = getEventSelect(event);
    if (!select) return;
    pendingCountry = normalizeCountry(select.value);
    pendingSelect = select;
    preservePendingSelection();
  }

  function clearPendingSelection() {
    pendingCountry = null;
    pendingSelect = null;
  }

  function parseMoney(text) {
    if (!text || /QAR|Qatari|Riyal/i.test(text)) return null;
    const normalized = text.replace(/\u00a0/g, ' ').replace(/,/g, '');
    const pattern = /([\-−])?\s*(?:USD|US\$|\$)\s*([0-9]+(?:\.[0-9]{1,2})?)|([\-−])?\s*([0-9]+(?:\.[0-9]{1,2})?)\s*(?:USD|US dollars?)/gi;
    const matches = Array.from(normalized.matchAll(pattern));
    if (!matches.length) return null;
    const match = matches[matches.length - 1];
    const amount = Number(match[2] || match[4]);
    if (!Number.isFinite(amount)) return null;
    return match[1] || match[3] ? -amount : amount;
  }

  function formatQar(usd) {
    const value = Math.abs(usd * rate);
    let formatted;
    try {
      formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'QAR',
        currencyDisplay: 'code',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      formatted = 'QAR ' + value.toFixed(2);
    }
    return usd < 0 ? '-' + formatted : formatted;
  }

  function render() {
    scheduled = 0;
    rendering = true;
    if (observer) observer.disconnect();
    document.querySelectorAll('[data-ura-qar-home-display]').forEach(node => node.remove());
    if (document.documentElement.classList.contains('ura-qar-active')) {
      document.querySelectorAll('#MainContent [id^="UraArrivals"] article strong').forEach(price => {
        const amount = parseMoney(price.textContent);
        if (amount === null) return;
        const display = document.createElement('span');
        const qar = formatQar(amount);
        display.className = 'ura-qar__home-amount';
        display.dataset.uraQarHomeDisplay = 'true';
        display.textContent = (config.approx || 'Approx.') + ' ' + qar;
        display.setAttribute('aria-label', (config.aria || 'Approximate QAR value. Checkout remains in USD.') + ' ' + qar);
        price.insertAdjacentElement('afterend', display);
      });
    }
    preservePendingSelection();
    observe();
    rendering = false;
  }

  function schedule() {
    if (rendering || scheduled) return;
    scheduled = window.requestAnimationFrame(render);
  }

  function observe() {
    if (!observer) observer = new MutationObserver(records => {
      const generated = '[data-ura-qar-display],[data-ura-qar-home-display],[data-ura-qar-note]';
      if (records.some(record => {
        if (record.type === 'attributes') return true;
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && target.closest(generated)) return false;
        const nodes = [...record.addedNodes,...record.removedNodes];
        return record.type !== 'childList' || !nodes.length || nodes.some(node => node.nodeType !== 1 || !node.matches(generated));
      })) schedule();
    });
    const main = document.querySelector('#MainContent');
    if (main) observer.observe(main, { childList: true, subtree: true, characterData: true });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  ['pageshow', 'popstate', 'shopify:section:load', 'variant:change', 'cart:updated', 'ura:cart:updated'].forEach(eventName => {
    window.addEventListener(eventName, schedule, { passive: true });
    document.addEventListener(eventName, schedule, { passive: true });
  });

  document.addEventListener('input', rememberPendingSelection, true);
  document.addEventListener('change', rememberPendingSelection, true);
  document.addEventListener('submit', event => {
    if (event.target && event.target.querySelector && event.target.querySelector(countrySelectSelector)) clearPendingSelection();
  }, true);
  document.addEventListener('click', event => {
    const target = event.target;
    if (target && target.closest && target.closest('[data-ura-qar-apply]')) clearPendingSelection();
  }, true);
  if (document.body) {
    selectionObserver = new MutationObserver(schedulePendingSelection);
    selectionObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  render();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-qatar-currency"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-ura-qatar-currency]');
  if (!root || root.dataset.uraReady === 'true') return;
  root.dataset.uraReady = 'true';

  const configNode = root.querySelector('[data-ura-qar-config]');
  let config = {};
  try {
    config = JSON.parse(configNode ? configNode.textContent : '{}');
  } catch (error) {
    config = {};
  }

  const rate = Number(config.rate || root.dataset.rate || 3.64);
  const storageKey = config.storageKey || 'ura_price_display_country';
  const doc = document.documentElement;
  const footerCard = root.querySelector('[data-ura-qar-footer-card]');
  const lead = root.querySelector('[data-ura-qar-lead]');
  const selects = root.querySelectorAll('[data-ura-qar-country-select]');
  const applyButtons = root.querySelectorAll('[data-ura-qar-apply]');
  const locale = config.locale || document.documentElement.lang || 'en';
  const skipSelector = [
    '[data-ura-qatar-currency]',
    '[data-ura-qar-display]',
    '.shopify-payment-button',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    'script',
    'style',
    'noscript',
    'select',
    'option',
    'textarea',
    'template'
  ].join(',');
  const rootSelector = [
    '[data-ura2-catalog]',
    '[data-ura4-product]',
    '.ura-cart',
    '#UraCartDrawer',
    '[data-ura-commerce]'
  ].join(',');
  const priceSelector = [
    '[class*="price"]',
    '[class*="total"] strong',
    '[class*="subtotal"] strong',
    '.ura2-product-card__info p',
    '.ura-cart__summary-row strong',
    '.ura-cart__summary-total strong',
    '.ura-cart-line__price',
    '.ura-cart-drawer__price',
    '.ura-cart-drawer__subtotal strong'
  ].join(',');
  let country = readCountry();
  let scheduled = 0;
  let rendering = false;
  let observer;

  function readCountry() {
    return root.dataset.country || config.country || selects[0]?.value || '';
  }

  function writeCountry(value) {
    const available = Array.from(selects[0]?.options || []).some(option => option.value === value);
    if (!available) return;
    country = value;
    selects.forEach(select => { select.value = country; });
  }

  function placeFooterCard() {
    if (!footerCard) return;
    const target =
      document.querySelector('#UraSiteFooter .uf28-assurance') ||
      document.querySelector('#UraSiteFooter .uf28-commerce') ||
      document.querySelector('#UraSiteFooter .uf28-end') ||
      document.querySelector('footer');
    if (target && footerCard.parentNode !== target) {
      target.insertBefore(footerCard, target.firstChild);
    }
  }

  function parseMoney(text) {
    if (!text || /QAR|Qatari|Riyal/i.test(text)) return null;
    const normalized = text.replace(/\u00a0/g, ' ').replace(/,/g, '');
    const pattern = /([\-−])?\s*(?:USD|US\$|\$)\s*([0-9]+(?:\.[0-9]{1,2})?)|([\-−])?\s*([0-9]+(?:\.[0-9]{1,2})?)\s*(?:USD|US dollars?)/gi;
    const matches = Array.from(normalized.matchAll(pattern));
    if (!matches.length) return null;
    const match = matches[matches.length - 1];
    const amount = Number(match[2] || match[4]);
    if (!Number.isFinite(amount)) return null;
    const negative = Boolean(match[1] || match[3]);
    return negative ? -amount : amount;
  }

  function formatQar(usd) {
    const value = Math.abs(usd * rate);
    let formatted;
    try {
      formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'QAR',
        currencyDisplay: 'code',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      formatted = 'QAR ' + value.toFixed(2);
    }
    return usd < 0 ? '-' + formatted : formatted;
  }

  function shouldSkip(element) {
    return !element || element.closest(skipSelector);
  }

  function hasPricedDescendant(element, amount) {
    return Array.from(element.querySelectorAll(priceSelector)).some(child => {
      if (shouldSkip(child)) return false;
      return parseMoney(child.textContent) === amount;
    });
  }

  function addDisplay(element, amount) {
    const span = document.createElement('span');
    const qar = formatQar(amount);
    span.className = 'ura-qar__amount';
    span.dataset.uraQarDisplay = 'true';
    span.textContent = (config.approx || 'Approx.') + ' ' + qar;
    span.setAttribute('aria-label', (config.aria || 'Approximate QAR value. Checkout remains in USD.') + ' ' + qar);
    element.insertAdjacentElement('afterend', span);
  }

  function scanPrices() {
    document.querySelectorAll('[data-ura-qar-display]').forEach(node => node.remove());
    if (country !== 'QA') return;
    const candidates = new Set();
    document.querySelectorAll(rootSelector).forEach(scope => {
      scope.querySelectorAll(priceSelector).forEach(element => candidates.add(element));
    });
    candidates.forEach(element => {
      if (shouldSkip(element)) return;
      const amount = parseMoney(element.textContent);
      if (amount === null) return;
      if (hasPricedDescendant(element, amount)) return;
      addDisplay(element, amount);
    });
  }

  function placeNotes() {
    document.querySelectorAll('[data-ura-qar-note]').forEach(note => note.remove());
    if (country !== 'QA') return;
    const noteText = config.note || 'QAR is informational only. Checkout remains in USD; bank exchange rates or fees may apply.';
    [
      '[data-ura4-product] .ura4-buy',
      '.ura-cart__summary',
      '#UraCartDrawer .ura-cart-drawer__foot'
    ].forEach(selector => {
      const target = document.querySelector(selector);
      if (!target || target.querySelector('[data-ura-qar-note]')) return;
      const note = document.createElement('p');
      note.className = 'ura-qar-note';
      note.dataset.uraQarNote = 'true';
      note.textContent = noteText;
      target.appendChild(note);
    });
  }

  function syncControl() {
    const active = country === 'QA';
    if (doc.classList.contains('ura-qar-active') !== active) doc.classList.toggle('ura-qar-active', active);
    if (footerCard && footerCard.dataset.country !== country) footerCard.dataset.country = country;
    syncCountryPicker();
    if (lead) lead.textContent = active ? (config.leadQar || 'Approximate QAR shown beside USD.') : (config.leadUsd || 'All charges remain in USD.');
    selects.forEach(select => {
      if (select.value !== country) select.value = country;
    });
  }

  function render() {
    scheduled = 0;
    rendering = true;
    if (observer) observer.disconnect();
    country = readCountry();
    syncControl();
    placeFooterCard();
    scanPrices();
    placeNotes();
    if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    rendering = false;
  }

  function schedule() {
    if (rendering || scheduled) return;
    scheduled = window.requestAnimationFrame(render);
  }

  applyButtons.forEach(button => {
    button.addEventListener('click', () => {
      const select = root.querySelector('[data-ura-qar-country-select]');
      writeCountry(select ? select.value : country);
    });
  });
  root.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', () => {
      const select = form.querySelector('[data-ura-qar-country-select]');
      if (select) writeCountry(select.value);
    });
  });

  const currencyGenerated = '[data-ura-qar-display],[data-ura-qar-home-display],[data-ura-qar-note]';
  const countryForm = root.querySelector('#UraQatarCurrencyForm');
  const countryTrigger = root.querySelector('[data-ura-country-trigger]');
  const countryPanel = root.querySelector('#UraCountryPanel');
  const countryLabel = root.querySelector('[data-ura-country-label]');
  const countryOptions = [...root.querySelectorAll('[data-ura-country-option]')];
  function syncCountryPicker() {
    const selectedOption = countryOptions.find(option => option.dataset.uraCountryOption === country);
    const label = selectedOption?.querySelector('span')?.textContent || countryLabel?.textContent || country;
    if (countryLabel && countryLabel.textContent !== label) countryLabel.textContent = label;
    countryOptions.forEach(option => {
      if (option.dataset.uraCountryOption === country) option.setAttribute('aria-current','true');
      else option.removeAttribute('aria-current');
    });
  }
  function setCountryOpen(open, focus) {
    if (!countryPanel || !countryTrigger) return;
    countryPanel.hidden = !open;
    countryTrigger.setAttribute('aria-expanded',String(open));
    if (open && focus) (countryOptions.find(option => option.hasAttribute('aria-current')) || countryOptions[0])?.focus();
  }
  if (countryForm && countryTrigger && countryPanel && countryOptions.length) {
    countryForm.dataset.enhanced = 'true'; countryTrigger.hidden = false;
    countryTrigger.addEventListener('click',() => setCountryOpen(countryPanel.hidden,false));
    countryTrigger.addEventListener('keydown',event => {
      if (['ArrowDown','ArrowUp'].includes(event.key)) { event.preventDefault(); setCountryOpen(true,true); }
    });
    countryOptions.forEach(option => option.addEventListener('click',() => {
      const code = option.dataset.uraCountryOption;
      if (code === country && code === root.dataset.country) { setCountryOpen(false); countryTrigger.focus(); return; }
      selects.forEach(select => { select.value = code; });
      writeCountry(code); setCountryOpen(false);
      let returnTo = countryForm.querySelector('[name="return_to"]');
      if (!returnTo) { returnTo=document.createElement('input');returnTo.type='hidden';returnTo.name='return_to';countryForm.append(returnTo); }
      returnTo.value = location.pathname + location.search + location.hash;
      if (countryForm.requestSubmit) countryForm.requestSubmit(); else countryForm.submit();
    }));
    countryForm.addEventListener('keydown',event => {
      if (event.key === 'Escape' && !countryPanel.hidden) { event.preventDefault();setCountryOpen(false);countryTrigger.focus(); }
      const index=countryOptions.indexOf(event.target);
      if (index >= 0 && ['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
        event.preventDefault();countryOptions[event.key==='Home'?0:event.key==='End'?countryOptions.length-1:(index+(event.key==='ArrowDown'?1:-1)+countryOptions.length)%countryOptions.length].focus();
      }
    });
    document.addEventListener('pointerdown',event => { if (!countryForm.contains(event.target)) setCountryOpen(false); });
    countryForm.addEventListener('focusout',event => { if (event.relatedTarget && !countryForm.contains(event.relatedTarget)) setCountryOpen(false); });
  }

  observer = new MutationObserver(records => {
    if (records.some(record => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target && target.closest(currencyGenerated)) return false;
      const nodes = [...record.addedNodes, ...record.removedNodes];
      return record.type !== 'childList' || !nodes.length || nodes.some(node => node.nodeType !== 1 || !node.matches(currencyGenerated));
    })) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  ['pageshow', 'popstate', 'shopify:section:load', 'variant:change', 'cart:updated', 'ura:cart:updated'].forEach(eventName => {
    window.addEventListener(eventName, schedule, { passive: true });
    document.addEventListener(eventName, schedule, { passive: true });
  });

  const originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function uraQarFetch(input, init) {
      const requestUrl = typeof input === 'string' ? input : input && input.url;
      const result = originalFetch.apply(this, arguments);
      if (requestUrl && /\/cart(?:\/|\.js|\/change|\/add|\/update|$)/.test(requestUrl)) {
        result.then(() => window.setTimeout(schedule, 80), () => {});
      }
      return result;
    };
  }

  render();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-story-motion"] && !Shopify.designMode) return;
  try {
    (()=>{
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const observed=new Set();
 const reveal=node=>{node.removeAttribute('data-ura-story-pending');observed.delete(node);};
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){reveal(entry.target);observer.unobserve(entry.target);}}),{threshold:0,rootMargin:'0px 0px -24px 0px'});
 const mount=scope=>{
  if(reduced.matches)return;
  scope.querySelectorAll('[data-ura-story-reveal],[data-ufe-category]').forEach(node=>{
   node.setAttribute('data-ura-story-reveal','');
   if(observed.has(node)||node.getBoundingClientRect().top<innerHeight)return;
   node.setAttribute('data-ura-story-pending','');observed.add(node);observer.observe(node);
  });
 };
 const revealAll=()=>{observed.forEach(reveal);observer.disconnect();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 reduced.addEventListener('change',()=>{if(reduced.matches)revealAll();});
 document.addEventListener('focusin',event=>{const node=event.target.closest('[data-ura-story-pending]');if(node){reveal(node);observer.unobserve(node);}});
 document.addEventListener('shopify:section:load',event=>mount(event.target));
 document.addEventListener('shopify:section:unload',event=>{observed.forEach(node=>{if(event.target.contains(node)){observer.unobserve(node);observed.delete(node);}});});
 window.addEventListener('beforeprint',revealAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-technology-badge-renderer"] && !Shopify.designMode) return;
  try {
    (()=>{
 if(window.__uraTechBadges0922)return;
 window.__uraTechBadges0922=true;
 const selector='details[data-ura-tech-disclosure]';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const seen=new WeakSet();
 const entrance='IntersectionObserver' in window?new IntersectionObserver(entries=>{
  entries.forEach(entry=>{
   if(!entry.isIntersecting)return;
   const frame=entry.target;entrance.unobserve(frame);
   if(reduced.matches)return;
   frame.setAttribute('data-tech-entered','');
   frame.querySelectorAll('[data-ura-tech-disclosure]').forEach(badge=>{
    badge.setAttribute('data-tech-arriving','');
    setTimeout(()=>badge.removeAttribute('data-tech-arriving'),4000);
   });
  });
 },{threshold:.3}):null;
 const initFrames=()=>document.querySelectorAll('[data-ura-tech-frame]').forEach(frame=>{if(seen.has(frame))return;seen.add(frame);entrance?.observe(frame);});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFrames,{once:true});else initFrames();
 document.addEventListener('shopify:section:load',initFrames);
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-ura-tech-frame]').forEach(frame=>entrance?.unobserve(frame)));
 let active=null,frame=0;
 const place=panel=>{
  if(!panel||!panel.open)return;
  const box=panel.querySelector('.ura-tech__panel'),summary=panel.querySelector('summary');
  if(!box||!summary)return;
  box.style.setProperty('--ura-tech-panel-x','0px');
  panel.removeAttribute('data-panel-side');
  const vv=window.visualViewport,left=vv?.offsetLeft||0,top=vv?.offsetTop||0,width=vv?.width||document.documentElement.clientWidth,height=vv?.height||innerHeight,bottom=top+height;
  const anchor=summary.getBoundingClientRect(),below=bottom-anchor.bottom-14,above=anchor.top-top-14;
  if(below<Math.min(box.scrollHeight,280)&&above>below)panel.dataset.panelSide='above';
  const available=panel.dataset.panelSide==='above'?above:below;
  box.style.maxHeight=Math.max(120,Math.min(390,available))+'px';
  const rect=box.getBoundingClientRect();let shift=0;
  if(rect.right>left+width-12)shift=left+width-12-rect.right;
  if(rect.left+shift<left+12)shift+=left+12-(rect.left+shift);
  box.style.setProperty('--ura-tech-panel-x',shift+'px');
 };
 const close=panel=>{if(panel){panel.open=false;if(active===panel)active=null;}};
 document.addEventListener('toggle',event=>{
  const panel=event.target instanceof Element&&event.target.matches(selector)?event.target:null;
  if(!panel)return;
  if(panel.open){
   if(active&&active!==panel)close(active);
   active=panel;
   requestAnimationFrame(()=>place(panel));
  }else if(active===panel)active=null;
 },true);
 document.addEventListener('pointerdown',event=>{if(active&&!active.contains(event.target))close(active);});
 document.addEventListener('keydown',event=>{if(event.key==='Escape'&&active){event.preventDefault();const summary=active.querySelector('summary');close(active);summary?.focus({preventScroll:true});}});
 const schedule=()=>{if(!active||frame)return;frame=requestAnimationFrame(()=>{frame=0;place(active);});};
 addEventListener('resize',schedule,{passive:true});
 addEventListener('scroll',schedule,{passive:true,capture:true});
 window.visualViewport?.addEventListener('resize',schedule,{passive:true});
 window.visualViewport?.addEventListener('scroll',schedule,{passive:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-visual-hero-blueprint-0919"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ura-visual-sequence')){
 customElements.define('ura-visual-sequence',class extends HTMLElement{
  connectedCallback(){
   this.events?.abort();
   this.observer?.disconnect();
   cancelAnimationFrame(this.frame);
   this.events=new AbortController();
   this.visibleRatio=0;
   const signal=this.events.signal;
   this.reduce=matchMedia('(prefers-reduced-motion: reduce)');
   this.closest('.uvh27__art,.uvj-hero__art')?.removeAttribute('aria-hidden');
   this.button=this.querySelector('.uvv21__replay');
   this.count=this.querySelector('[data-uvv-count]');
   this.button.hidden=this.reduce.matches;
   this.syncPlayback=()=>this.style.setProperty('--uvv-play',!document.hidden&&this.visibleRatio>.12&&!this.reduce.matches?'running':'paused');
   document.addEventListener('visibilitychange',this.syncPlayback,{signal});
   this.button.addEventListener('click',()=>{
    this.classList.remove('is-started');
    this.count.textContent='01 / 03';
    cancelAnimationFrame(this.frame);
    this.frame=requestAnimationFrame(()=>{this.frame=requestAnimationFrame(()=>{if(this.isConnected&&!this.reduce.matches)this.classList.add('is-started')})});
   },{signal});
   this.addEventListener('animationstart',event=>{
    if(event.animationName!=='uvv21-focus')return;
    const index=Number(event.target.style.getPropertyValue('--step'))+1;
    this.count.textContent='0'+index+' / 03';
   },{signal});
   this.reduce.addEventListener('change',()=>{
    this.button.hidden=this.reduce.matches;
    if(this.reduce.matches){cancelAnimationFrame(this.frame);this.classList.remove('is-started');this.count.textContent='03 / 03'}
    else if(this.visibleRatio>=.65)this.classList.add('is-started');
    this.syncPlayback();
   },{signal});
   if(this.reduce.matches)this.count.textContent='03 / 03';
   if(!('IntersectionObserver' in window)){this.visibleRatio=1;this.syncPlayback();if(!this.reduce.matches)this.classList.add('is-started');return;}
   this.observer=new IntersectionObserver(entries=>{
    const ratio=entries[0].intersectionRatio;
    this.visibleRatio=ratio;
    if(ratio>=.65&&!this.reduce.matches)this.classList.add('is-started');
    this.syncPlayback();
   },{threshold:[0,.12,.65]});
   this.observer.observe(this);
  }
  disconnectedCallback(){this.observer?.disconnect();this.events?.abort();cancelAnimationFrame(this.frame)}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-visual-home"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>document.querySelectorAll('[data-uv-home-intro]').forEach(root=>{if(root.dataset.motionReady)return;root.dataset.motionReady='true';if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion:reduce)').matches)return;const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){root.classList.add('is-visible');observer.disconnect();}},{threshold:.35});observer.observe(root);});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ura-visual-narrative"] && !Shopify.designMode) return;
  try {
    (()=>{
 const reduced=matchMedia('(prefers-reduced-motion:reduce)'),mounted=new Map(),clamp=(n,min=0,max=1)=>Math.max(min,Math.min(max,n)),smooth=n=>{n=clamp(n);return n*n*(3-2*n);};
 const mount=scope=>scope.querySelectorAll('[data-ura-visual-page]').forEach(page=>{
  if(mounted.has(page))return;
  const track=page.querySelector('[data-uv40-story]'),stage=track.querySelector('[data-uv40-stage]'),panels=[...track.querySelectorAll('[data-uv40-panel]')],tabs=[...track.querySelectorAll('[data-uv40-tab]')],nav=track.querySelector('.uv40-tabs'),heroTrack=page.querySelector('[data-uv42-hero-track]'),hero=page.querySelector('[data-uv40-hero]'),method=page.querySelector('[data-uv42-method]'),methodItems=[...method.querySelectorAll('li')],drawings=[...method.querySelectorAll('[data-uv42-drawing]')],manifesto=page.querySelector('.uv40-manifesto'),services=[...page.querySelectorAll('.uv40-services details')],project=page.querySelector('.uv40-project'),events=new AbortController();
  let frame=0,measureFrame=0,top=88,height=640,step=640,heroTravel=480,methodStep=520,pinned=false,visible=true,index=0;
  const put=(node,key,value)=>node.style.setProperty(key,String(value));
  const progress=(node,travel)=>clamp((top-node.getBoundingClientRect().top)/travel);
  const entering=node=>{const r=node.getBoundingClientRect();return reduced.matches?1:clamp((innerHeight*.9-r.top)/Math.max(200,Math.min(innerHeight*.7,r.height)));};
  const activePanel=(chosen)=>{
   const focusIndex=panels.findIndex(panel=>panel.contains(document.activeElement));
   if(focusIndex>=0&&focusIndex!==chosen)return focusIndex;
   index=chosen;panels.forEach((panel,i)=>{panel.inert=pinned&&i!==index;panel.toggleAttribute('data-uv42-active',!pinned||i===index);if(pinned&&i!==index)panel.setAttribute('aria-hidden','true');else panel.removeAttribute('aria-hidden');});tabs.forEach((tab,i)=>tab.setAttribute('aria-pressed',String(i===index)));return chosen;
  };
  const paint=()=>{
   frame=0;if(document.hidden||!visible)return;
   if(pinned){
    const heroP=progress(heroTrack,heroTravel),opening=smooth(heroP/.8);put(heroTrack,'--uv42-hero-inset',`${(1-opening)*5}%`);put(heroTrack,'--uv42-hero-scale',1.1-.1*opening);put(heroTrack,'--uv42-hero-copy',`${-22*opening}px`);
    panels.forEach(panel=>{panel.inert=false;panel.removeAttribute('aria-hidden');panel.toggleAttribute('data-uv42-active',true);const local=smooth(entering(panel.querySelector('.uv40-thought,.uv40-identity,.uv40-atelier,.uv40-world')||panel));put(panel,'--uv40-local',local);});
    put(heroTrack,'--uv50-orbit',opening);put(heroTrack,'--uv50-photo',smooth((heroP-.35)/.65));
    const methodPosition=clamp((top-method.getBoundingClientRect().top)/methodStep,0,methodItems.length-.001),methodIndex=Math.floor(methodPosition),local=smooth(clamp((methodPosition-methodIndex)/.55+.12));
    methodItems.forEach((item,i)=>{const selected=i===methodIndex;item.inert=!selected;if(selected)item.removeAttribute('aria-hidden');else item.setAttribute('aria-hidden','true');put(item,'--uv42-method-opacity',selected?1:0);put(item,'--uv42-method-y',`${selected?30*(1-local):0}px`);});
    drawings.forEach((drawing,i)=>{put(drawing,'--uv42-drawing-opacity',i===methodIndex?1:0);put(drawing,'--uv42-drawing-dash',1-local);put(drawing,'--uv42-drawing-y',`${22*(1-local)}px`);});put(method,'--uv42-method-progress',methodPosition/(methodItems.length-.06));method.dataset.uv42MethodStep=String(methodIndex+1);
   }else{
    panels.forEach(panel=>put(panel,'--uv40-local',entering(panel.querySelector('.uv40-thought,.uv40-identity,.uv40-atelier,.uv40-world')||panel)));
   }
   const m=smooth(entering(manifesto));put(manifesto,'--uv42-manifesto-mask',`${(1-m)*18}%`);put(manifesto,'--uv42-manifesto-y',`${(1-m)*65}px`);put(manifesto,'--uv42-manifesto-second',.35+.65*m);
   services.forEach(item=>{const p=smooth(entering(item));put(item,'--uv42-service-y',`${(1-p)*26}px`);put(item,'--uv42-service-opacity',.55+.45*p);});const ending=smooth(entering(project));put(project,'--uv42-project-y',`${(1-ending)*55}px`);put(project,'--uv42-project-mask',`${(1-ending)*55}%`);
  };
  const queue=()=>{if(!frame)frame=requestAnimationFrame(paint);};
  const measure=()=>{
   measureFrame=0;top=Math.ceil(document.querySelector('[data-ura-header]')?.getBoundingClientRect().height||72)+4;const preview=document.getElementById('PBarNextFrame')?76:0;height=Math.floor((window.visualViewport?.height||innerHeight)-top-preview-8);pinned=!reduced.matches&&height>=330;step=Math.max(320,height*.97);heroTravel=height*1.18;methodStep=Math.max(360,height*1.08);
   [track,heroTrack,method].forEach(node=>{node.style.setProperty('--uv42-top',`${top}px`);node.style.setProperty('--uv42-height',`${height}px`);node.toggleAttribute('data-uv42-compact',height<520);node.toggleAttribute('data-uv42-tiny',height<450);});
   track.toggleAttribute('data-pinned',false);heroTrack.toggleAttribute('data-uv42-pinned',pinned);method.toggleAttribute('data-uv42-pinned',pinned);track.style.height='';heroTrack.style.height=pinned?`${height+heroTravel}px`:'';method.style.height=pinned?`${height+methodStep*methodItems.length}px`:'';put(stage,'--uv40-top',`${top}px`);put(stage,'--uv40-height',`${height}px`);nav.hidden=true;
   panels.forEach(panel=>{panel.hidden=false;if(!pinned){panel.inert=false;panel.removeAttribute('aria-hidden');['--uv42-panel-opacity','--uv42-panel-z','--uv42-panel-y','--uv42-panel-clip'].forEach(key=>panel.style.removeProperty(key));}});
   if(!pinned){methodItems.forEach(item=>{item.inert=false;item.removeAttribute('aria-hidden');item.style.removeProperty('--uv42-method-opacity');item.style.removeProperty('--uv42-method-y');});['--uv42-hero-inset','--uv42-hero-scale','--uv42-hero-copy'].forEach(key=>heroTrack.style.removeProperty(key));}
   page.dataset.uv42Motion=pinned?'scroll':'flow';paint();
  };
  tabs.forEach((tab,i)=>tab.addEventListener('click',()=>{if(pinned){window.scrollTo({top:Math.max(0,scrollY+track.getBoundingClientRect().top-top+step*(i+.25)),behavior:reduced.matches?'instant':'smooth'});}else panels[i].scrollIntoView({block:'start',behavior:'instant'});},{signal:events.signal}));
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)queue();},{rootMargin:'200px'});observer.observe(page);
  const resized=()=>{if(!measureFrame)measureFrame=requestAnimationFrame(measure);},resize=new ResizeObserver(resized),header=document.querySelector('[data-ura-header]');if(header)resize.observe(header);
  window.addEventListener('scroll',queue,{passive:true,signal:events.signal});window.addEventListener('resize',resized,{passive:true,signal:events.signal});window.addEventListener('pageshow',measure,{signal:events.signal});reduced.addEventListener('change',measure,{signal:events.signal});track.addEventListener('focusout',queue,{signal:events.signal});
  mounted.set(page,()=>{events.abort();observer.disconnect();resize.disconnect();cancelAnimationFrame(frame);cancelAnimationFrame(measureFrame);mounted.delete(page);});measure();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);document.addEventListener('shopify:section:load',e=>mount(e.target));document.addEventListener('shopify:section:unload',e=>mounted.forEach((destroy,node)=>{if(e.target.contains(node))destroy();}));
})();
  } catch(e) { console.error(e); }
})();

})();
